import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import DateConversion from "../../../../utils/DateConversion";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllProjects } from "../../../../store/slices/projectsSlice";
import { fetchEmployees } from "../../../../store/slices/employeeSlice";
import { fetchLeads } from "../../../../store/slices/leadsSlice";
import { deleteTask, fetchWorkEntries, fetchWorkEntriesProjectTracking } from "../../../../store/slices/workentriesSlice";
import { fetchDescriptionTasks } from "../../../../store/slices/DescriptionTask";
import { fetchHardwareDescriptions, fetchHardwareProjectTracking } from "../../../../store/slices/hardwareDescriptionSlice";
import { getAllAutoSaveWorkentries } from "../../../../store/slices/autosaveSlice";
import { fetchHardware } from "../../../../store/slices/hardwareSlice";
import { getAllAssemblyInventory } from "../../../../store/slices/assemblyInventorySlice";
import { setmytrainingOMProjectAssignedState, setmytrainingOMProjectRequestState, setSelectedTabState } from "../../../../store/slices/OperationSlices/operationStateSlice";
import { cancelPersonFromProject } from "../../../../store/slices/cancelPersonFromProjectSlice";
import { setProjectReadTrue } from "../../../../store/slices/readSlice";
import { getMyTrainings } from "../../../../store/slices/MyTraining/myTrainings";
import AdminLoader from "../../../../components/common/loader/AdminLoader";
import ManagerMyProjects from "../ManagerMyProjects";
import SpeedometerGraph from "../../OperationFeatures/SpeedometerGraph";
import TimeEntriesGraph from "../../OperationFeatures/TimeEntriesGraph";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TaskInHand from "../../OperationFeatures/TaskInHand";
import UtilizationReport from "../../OperationFeatures/UtilizationReport";
import MyTraining from "../../../MyTraining/MyTraining";
import OmProjectApprovedDash from "../ProjectApproved/OmProjectApprovedDash";
import ProjectAssignManager from "../ProjectAssign/ProjectAssignManager";
import ProjectOngoingManager from "../ProjectOngoing/ProjectOngoingManager";
import ProjectCompletedManager from "../ProjectCompleted/ProjectCompletedManager";
import OPProjectRequestedPM from "../OperationToManagerAccess/OPProjectrequestedPM/OPProjectRequestedPM";
import OPMyRequestPM from "../OperationToManagerAccess/OPMyRequestPM";
import { hasViewOrFullAccess, getFeatureAccessLevel } from "../../../../utils/featureAccessUtils";
import { setActiveBucketName, clearActiveBucketName } from "../../../../store/slices/Sidebar/ProcessGuideSlice";
import {
  setToolGuideBucket,
  setToolGuideRole,
  clearToolGuidePath,
} from "../../../../store/slices/Sidebar/ToolGuideSlice";
import { MANAGER_BUCKET_KEYS } from "../../../../features/toolGuide/toolGuideConfig";
import useToolGuideSync from "../../../../features/toolGuide/useToolGuideSync";
import { MdSearch } from "react-icons/md";
import { isProjectLinkedToLostLead } from "../../../../utils/syncLeadProjectBucketStatus";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import DatePicker from "react-datepicker";
import AssignedPersonList from "./AssignedPersonList";
import FileAttachmentPopup from "../FileAttachmentPopup";
import TaskInputTable from "./TaskInputTable";
import { ChevronRightIcon } from "lucide-react";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { assignUserToProject } from "../../../../store/slices/managerAssignuserSlice";
import { projectAction } from "../../../../store/slices/managerActionSlice";
import { handleProjectAction } from "../../../../store/slices/projectmanagerActionSlice";
import { updateManagerAction } from "../../../../store/slices/managerCompleteSlice";
import { operationActionReassign } from "../../../../store/slices/operationReassignSlice";
import { managerActionRecall } from "../../../../store/slices/managerActionRecallSlice";
import { fetchGroups } from "../../../../store/slices/groupSlice";
import OPProjectapprovedPM from "../OperationToManagerAccess/OPProjectApprovedPM/OPProjectapprovedPM";
import OPProjectassignPM from "../OperationToManagerAccess/OPProjectAssignPM/OPProjectassignPM";
import OPProjectOngoingOPDashPM from "../OperationToManagerAccess/OPProjectOngoingPM/OPProjectOngoingOPDashPM";
import OPProjectCompletedDashPM from "../OperationToManagerAccess/OPProjectCompletePM/OPProjectCompletedDashPM";
import ManagerFinance from "../ManagerFinance/ManagerFinance";
import HardwareParent from "./Hardware/HardwareParent";
import ActionDropdown from "./ActionDropdown";
import ManagerTaskInputTable from "./ManagerTaskInputTable";
import { mergeDescriptionTasksWithTrainingExpenseRows } from "../../../../utils/trainingOtherExpenseSync";

const emptyRow = { task: "", hoursassigned: "", notes: "" };

const ManagerAssignment = ({
  filteredOngoingProjects,
  filteredOngoingEntries,
  filteredOngoingHardwareParts,
  emp,
  EmpEmail
}) => {
  const { formatDateByCountry, getDatePlaceholder, getDateFormat } =
    DateConversion();
  const [fileNames, setFileNames] = useState({}); // e.g., [{ name, base64 }, ...]
  const { enqueueSnackbar } = useSnackbar();
  const popupRef = useRef(null);
  const dispatch = useDispatch();
  const { syncToolGuideStep } = useToolGuideSync(
    MANAGER_BUCKET_KEYS.PROJECT_REQUESTS,
    "L4_PM"
  );

  const [requestedprojects, Setrequestedprojects] = useState([]);

  const [approvedProjectsManager, setApprovedProjectsManager] = useState([]);
  const [assignedProjectsManager, setAssignedProjectsManager] = useState([]);
  const [ongoingProjectsManager, setOngoingProjectsManager] = useState([]);
  const [completeProjectsManager, setCompleteProjectsManager] = useState([]);

  const [Project, setProject] = useState("");
  const [selectedselfemail, setselectedselfemail] = useState("");
  // const [showproject, SetShowproject] = useState(false);
  const [showLogout, setshowlogout] = useState(false);
  const [selectedAction, setselectedAction] = useState("");
  // const [showTaskDropdown, setShowTaskDropdown] = useState("");
  const [taskTableRowId, setTaskTableRowId] = useState(null);
  const [managerOPID, setManagerOPID] = useState(null);
  const [managerOPProject, setManagerOPProject] = useState(null);
  const [opemail, setopemail] = useState(null);

  const handleTaskTableClick = (rowId) => {
    if (!isViewOnlyMyRequests) {
      syncToolGuideStep("fill-details");
    }
    setTaskTableRowId(rowId);
  };
  const [showprojectDetails, SetShowprojectDetails] = useState(false);
  const [managerViewEmpTask, setManagerViewEmpTask] = useState(false);
  const [checkedRows, setCheckedRows] = useState({}); // Track checked state by row ID

  const [rows, setRows] = useState([]);
  const [managerSelectedEmpOnChange, setManagerSelectedEmpOnChange] = useState({
    WorkEntries: [],
  });
  const { hardwareProjectTracking } = useSelector(
    (state) => state.hardwareDescription
  );

  const [, setManagerSelectedEmp] = useState([]);
  const { employees } = useSelector((state) => state.employees);

  const employeeslist = useSelector((state) => state.employees.employees);
  const session = useSelector((state) => state.session);
  const { projects } = useSelector((state) => state.projects);
  const { leads } = useSelector((state) => state.leads);

  const selectedTabState = useSelector(
    (state) => state.operationState.selectedTabState
  );
  console.log("selectedTaskId selectedTabState ", selectedTabState);

  // Used to force "Project Ongoing" re-open + re-scroll when a new task is clicked,
  // even if `selectedTabState` is already "projectOngoing".
  const selectedProjectName = useSelector(
    (state) => state.taskScroll.selectedProjectName
  );
  const selectedTaskId = useSelector((state) => state.taskScroll.selectedTaskId);

  // Reset tab state on mount so My Request does not open stuck on Project Ongoing – user can click any tab
  useEffect(() => {
    dispatch(setSelectedTabState(""));
    setShowprojectrequest(false);
    setShowaproved(false);
    setShowassign(false);
    setShowongoing(false);
    setShowcomplete(false);
    setShowprojectrequestPM(false);
    setShowaprovedPM(false);
    setShowassignPM(false);
    setShowongoingPM(false);
    setShowcompletePM(false);
    dispatch(clearActiveBucketName());
  }, [dispatch]);

  const { entries } = useSelector((state) => state.workentries);
  const { tasks } = useSelector((state) => state.descriptionTasks);
  const { mytrainings } = useSelector((state) => state.myTrainings);
  const { items } = useSelector((state) => state.hardwareDescription);
  const { group: groups } = useSelector((state) => state.group);
  const hardwareData = useSelector((state) => state.hardware.data);
  const { autosaveentries } = useSelector((state) => state.autosave);
  const { inventory } = useSelector((state) => state.assemblyInventory);

  const groupNameById = useMemo(() => {
    const map = new Map();
    (groups || []).forEach((g) => {
      const id = g?._id || g?.id;
      const name = g?.newGroupName || g?.groupname || g?.groupName || g?.name || "";
      if (id && name) map.set(String(id), name);
    });
    return map;
  }, [groups]);

  const getDisplayGroupName = useCallback(
    (projectRow) => {
      const directGroupName =
        projectRow?.groupid?.newGroupName ||
        projectRow?.groupid?.groupname ||
        projectRow?.groupid?.groupName ||
        projectRow?.groupid?.name ||
        projectRow?.groupId?.newGroupName ||
        projectRow?.groupId?.groupname ||
        projectRow?.groupId?.groupName ||
        projectRow?.groupId?.name ||
        projectRow?.lead?.groupid?.newGroupName ||
        projectRow?.lead?.groupid?.groupname ||
        projectRow?.lead?.groupid?.groupName ||
        projectRow?.lead?.groupid?.name ||
        projectRow?.lead?.groupId?.newGroupName ||
        projectRow?.lead?.groupId?.groupname ||
        projectRow?.lead?.groupId?.groupName ||
        projectRow?.lead?.groupId?.name;

      if (directGroupName) return directGroupName;

      const groupId =
        projectRow?.groupid?._id ||
        projectRow?.groupid?.id ||
        projectRow?.groupid ||
        projectRow?.groupId?._id ||
        projectRow?.groupId?.id ||
        projectRow?.groupId ||
        projectRow?.lead?.groupid?._id ||
        projectRow?.lead?.groupid?.id ||
        projectRow?.lead?.groupid ||
        projectRow?.lead?.groupId?._id ||
        projectRow?.lead?.groupId?.id ||
        projectRow?.lead?.groupId;
      if (groupId && groupNameById.has(String(groupId))) {
        return groupNameById.get(String(groupId));
      }
      return projectRow?.AssignedGroup || "";
    },
    [groupNameById]
  );

  const [selectedTab, setSelectedTab] = useState(""); // default to first tab
  const [isSelf, setIsSelfChecke] = useState(false);

  const [showprojectrequest, setShowprojectrequest] = useState(false);
  const [showaproved, setShowaproved] = useState(false);
  const [showassign, setShowassign] = useState(false);
  const [showongoing, setShowongoing] = useState(false);
  const [showcomplete, setShowcomplete] = useState(false);
  const [currentEmployee, setcurrentEmployee] = useState();
  const email = localStorage.getItem("email");


  const [showprojectrequestPM, setShowprojectrequestPM] = useState(false);
  const [showaprovedPM, setShowaprovedPM] = useState(false);
  const [showassignPM, setShowassignPM] = useState(false);
  const [showongoingPM, setShowongoingPM] = useState(false);
  const [showcompletePM, setShowcompletePM] = useState(false);
  console.log("currentEmployee", window.innerWidth);

  useEffect(() => {
    const employee = employees.find((emp) => emp.EmpEmail === email);
    console.log("fsgsdg", employee);
    setcurrentEmployee(employee);
  }, [email, employees]);

  // Clear bucket name when all buckets are closed
  useEffect(() => {
    if (!showprojectrequest && !showaproved && !showassign && !showongoing && !showcomplete) {
      dispatch(clearActiveBucketName());
      dispatch(clearToolGuidePath());
    }
  }, [showprojectrequest, showaproved, showassign, showongoing, showcomplete, dispatch]);

  // Check if logged-in manager is a hardware manager
  const isHardwareManager = currentEmployee?.servicetype?.toLowerCase() === "hardware";
  // For hardware managers, show hardware employee layout (hide APPROVED HRS and PROJECTS & TIME ENTRIES)
  const showHardwareLayout = isHardwareManager;

  const hasNoFeatureConfig =
    !currentEmployee?.featureAccess || currentEmployee.featureAccess.length === 0;

  const canShowCard = (featureName) => {
    if (hasNoFeatureConfig) return true;
    if (hasViewOrFullAccess(currentEmployee, featureName)) return true;
    if (!getFeatureAccessLevel(currentEmployee, featureName)) {
      return hasViewOrFullAccess(currentEmployee, "MY MANAGEMENT");
    }
    return false;
  };

  const taskInHandAccessLevel = getFeatureAccessLevel(currentEmployee, "TASK IN HAND");
  const isViewOnlyTaskInHand = !hasNoFeatureConfig && taskInHandAccessLevel &&
    String(taskInHandAccessLevel).trim().toUpperCase() === "VIEW ONLY";

  const utilizationAccessLevel = getFeatureAccessLevel(currentEmployee, "UTILISATION REPORT");
  const isViewOnlyUtilization = !hasNoFeatureConfig && utilizationAccessLevel &&
    String(utilizationAccessLevel).trim().toUpperCase() === "VIEW ONLY";

  const myRequestAccessLevel = getFeatureAccessLevel(currentEmployee, "MY REQUEST");
  const isViewOnlyMyRequests = !hasNoFeatureConfig && myRequestAccessLevel &&
    String(myRequestAccessLevel).trim().toUpperCase() === "VIEW ONLY";

  const plAccessLevel = getFeatureAccessLevel(currentEmployee, "PROFIT AND LOSS");
  const isViewOnlyPL = !hasNoFeatureConfig && plAccessLevel && String(plAccessLevel).trim().toUpperCase() === "VIEW ONLY";

  console.log("Access Level - MY REQUEST:", myRequestAccessLevel, "isViewOnly:", isViewOnlyMyRequests);
  console.log("Access Level - TASK IN HAND:", taskInHandAccessLevel, "isViewOnly:", isViewOnlyTaskInHand);
  console.log("Access Level - UTILISATION REPORT:", utilizationAccessLevel, "isViewOnly:", isViewOnlyUtilization);

  useEffect(() => {
    if (emp === "manager") {
      setShowprojectrequestPM(false)
      setShowaprovedPM(false)
      setShowassignPM(false)
      setShowongoingPM(false)
      setShowcompletePM(false)
    } else if (emp !== "manager") {
      setShowprojectrequest(false)
      setShowaproved(false)
      setShowassign(false)
      setShowongoing(false)
      setShowcomplete(false)

    }
  }, [emp]);

  const ProjectRequestRef = useRef(null);

  const ProjectRequestsRef = useRef(null);
  const ProjectApprovedRef = useRef(null);
  const ProjectAssignedRef = useRef(null);
  const ProjectOngoingRef = useRef(null);
  const ProjectCompletedRef = useRef(null);

  const refsMap = useMemo(
    () => ({
      ProjectRequests: ProjectRequestsRef,
      ProjectApproved: ProjectApprovedRef,
      projectAssign: ProjectAssignedRef,
      projectOngoing: ProjectOngoingRef,
      projectCompleted: ProjectCompletedRef,
    }),
    []
  );

  // one function to handle tab change + scroll
  const handleTabClick = useCallback(
    (tabKey) => {
      setSelectedTab(tabKey);
      setTimeout(() => {
        refsMap[tabKey]?.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100); // slight delay so component mounts first
    },
    [refsMap, setSelectedTab]
  );

  useEffect(() => {
    if (selectedTabState !== "projectOngoing") return;

    // Always force the "Ongoing" bucket open on task selection.
    setShowongoing(true);
    setShowassign(false);
    setShowprojectrequest(false);
    setShowaproved(false);
    setShowcomplete(false);

    // Scroll after the bucket mounts.
    handleTabClick("projectOngoing");
  }, [
    selectedTabState,
    selectedProjectName,
    selectedTaskId,
    handleTabClick,
  ]);

  // const [selectedProjectName,setSelectedProjectName] = useState("");
  const [openProbabilityIndex, setOpenProbabilityIndex] = useState(null);
  const [probabilityList, setProbabilityList] = useState([]);
  const [dateValues, setDateValues] = useState([]);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [assignedPeopleList, setAssignedPeopleList] = useState({});
  const [employeesfinalList, setEmployeesfinalList] = useState([]);

  const [isLoading, SetisLoading] = useState(false);
  const [isLoadingtask, SetisLoadingtask] = useState(false);

  const [sourceName, setSourceName] = useState("");
  const [selectedemail, setSelectedEmail] = useState("");
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedServiceType, setSelectedServiceType] = useState("");
  const [rowsManager, setRowsManager] = useState([]);
  const [Action, setAction] = useState("task");
  const [serviceofuser, setServiceofuser] = useState("task");
  const [hardwareAction, setHardwareAction] = useState("hardwarecost");
  const descriptionTasksMergedForAssignmentRow = useCallback(
    (assignmentRow) =>
      mergeDescriptionTasksWithTrainingExpenseRows(tasks, {
        row: assignmentRow,
        managerOPProject,
        trainingsEnvelope: mytrainings,
        employees,
        projects,
        selectedemail,
        opemail,
        enableDebugLogs: assignmentRow?._id === taskTableRowId,
      }),
    [
      tasks,
      managerOPProject,
      mytrainings,
      employees,
      projects,
      selectedemail,
      opemail,
      taskTableRowId,
    ]
  );
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [showcompletepopup, Setshowcompletepopup] = useState(false);
  const [showcompleteperson, Setshowcompleteperson] = useState("");
  const [showcompleteproject, Setshowcompleteproject] = useState("");
  const [selectedSelfAction, setSelectedSelfAction] = useState("");

  const [unreadleadcountrequest, setunreadleadcountrequest] = useState([]);
  const [unreadleadcountapproved, setunreadleadcountapproved] = useState([]);
  const [unreadleadcountassign, setunreadleadcountassign] = useState([]);
  const [unreadleadcountongoing, setunreadleadcountongoing] = useState([]);
  const [unreadleadcountcomplete, setunreadleadcountcomplete] = useState([]);

  console.log("Hdfdfemployees", employees);



  const [requestedprojectsDataPM, SetrequestedprojectsDataPM] = useState([]);
  const [approvedProjectsManagerDataPM, setApprovedProjectsManagerDataPM] = useState([]);
  const [assignedProjectsManagerDataPM, setAssignedProjectsManagerDataPM] = useState([]);
  const [ongoingProjectsManagerDataPM, setOngoingProjectsManagerDataPM] = useState([]);
  const [completeProjectsManagerDataPM, setCompleteProjectsManagerDataPM] = useState([]);
  const [projectsRequestDataPM, setProjectsRequestDataPM] = useState([]);

  // When Assign Task To Employees block is opened, do not select Self by default
  useEffect(() => {
    if (expandedRowId) {
      setIsSelfChecke(false);
      setCheckedRows((prev) => ({ ...prev, [expandedRowId]: false }));
    }
  }, [expandedRowId]);

  useEffect(() => {
    const unreadProjects = requestedprojects.filter(
      (project) => project.isRead === false
    );
    setunreadleadcountrequest(unreadProjects);
  }, [requestedprojects]);

  useEffect(() => {
    const unreadProjects = assignedProjectsManager.filter(
      (project) => project.isRead === false
    );
    setunreadleadcountassign(unreadProjects);
  }, [assignedProjectsManager]);

  useEffect(() => {
    const unreadProjects = ongoingProjectsManager.filter(
      (project) => project.isRead === false
    );
    setunreadleadcountongoing(unreadProjects);
  }, [ongoingProjectsManager]);

  useEffect(() => {
    const unreadProjects = completeProjectsManager.filter(
      (project) => project.isRead === false
    );
    setunreadleadcountcomplete(unreadProjects);
  }, [completeProjectsManager]);

  useEffect(() => {
    const unreadProjects = approvedProjectsManager.filter(
      (project) => project.isRead === false
    );
    setunreadleadcountapproved(unreadProjects);
  }, [approvedProjectsManager]);

  const [isOpen, setIsOpen] = useState(false);

  const [showselfcompletepopup, Setshowselfcompletepopup] = useState(false);
  const [selfcompleterow, setselfcompleterow] = useState("");

  const { projectTrackingWorkEntries } = useSelector(
    (state) => state.workentries
  );
  const [, setongoingEntries] = useState([]);
  const [, setongoingHardwareParts] = useState([]);

  useEffect(() => {
    dispatch(fetchAllProjects());
    dispatch(fetchEmployees());
    dispatch(fetchLeads());
    dispatch(getMyTrainings());
    dispatch(fetchWorkEntries());
    dispatch(fetchDescriptionTasks());
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchGroups());
    dispatch(getAllAutoSaveWorkentries());
    dispatch(fetchHardware());
    dispatch(fetchWorkEntriesProjectTracking());
    dispatch(fetchHardwareProjectTracking());
    dispatch(getAllAssemblyInventory());
  }, [dispatch]);

  const handlerefresh = () => {
    dispatch(fetchAllProjects());
    dispatch(fetchEmployees());
    dispatch(fetchLeads());
    dispatch(getMyTrainings());
    dispatch(fetchWorkEntries());
    dispatch(fetchDescriptionTasks());
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchGroups());
    dispatch(getAllAutoSaveWorkentries());
    dispatch(fetchHardware());
  };

  const handlerefreshagain = React.useCallback(() => {
    dispatch(getAllAutoSaveWorkentries());
    dispatch(fetchHardware());
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchDescriptionTasks());
  }, [dispatch]);

  const handlerehardfresh = () => {
    dispatch(fetchHardwareDescriptions());
  };

  useEffect(() => {
    const email = localStorage.getItem("email") || session.email;

    const filteredProjects = projects.filter(
      (project) =>
        project.ProjectManagerStatus === "project requested" &&
        project.AssignedManagerEmail?.includes(email) &&
        !isProjectLinkedToLostLead(project, leads)
    );

    if (!filteredProjects) return;

    const allProjectArrays = [
      approvedProjectsManager,
      assignedProjectsManager,
      ongoingProjectsManager,
      completeProjectsManager,
    ];

    const getQuotationId = (p) => p?.quotationId ?? p?.QuotationId ?? null;
    const updatedProjects = filteredProjects?.filter((requestProject) => {
      const isMatched = allProjectArrays?.some((projectArray) =>
        projectArray?.some(
          (project) => {
            const qId1 = getQuotationId(project);
            const qId2 = getQuotationId(requestProject);
            if (qId1 != null && qId2 != null) {
              return String(qId1) === String(qId2);
            }
            return project.ProjectName === requestProject.ProjectName &&
              project.TypeService === requestProject.TypeService;
          }
        )
      );
      return !isMatched;
    });




    Setrequestedprojects(updatedProjects);
  }, [
    projects,
    leads,
    session,
    approvedProjectsManager,
    assignedProjectsManager,
    ongoingProjectsManager,
    completeProjectsManager,
  ]);

  const LoggedUser = localStorage.getItem("email");

  useEffect(() => {
    const filtered = projects.filter(
      (proj) =>
        Array.isArray(proj.Assignedperson) &&
        proj.Assignedperson.some(
          (person) => person.managerstatus === "project approved"
        ) &&
        !isProjectLinkedToLostLead(proj, leads)
    );
    const managerProjects = filtered.filter((proj) =>
      proj.Assignedperson?.some(
        (person) => person.email?.toLowerCase() === LoggedUser?.toLowerCase()
      )
    );

    if (!managerProjects) return;

    const allProjectArrays = [
      assignedProjectsManager,
      ongoingProjectsManager,
      completeProjectsManager,
    ];

    const getQuotationId = (p) => p?.quotationId ?? p?.QuotationId ?? null;
    const updatedProjects = managerProjects?.filter((requestProject) => {
      const isMatched = allProjectArrays?.some((projectArray) =>
        projectArray?.some(
          (project) => {
            const qId1 = getQuotationId(project);
            const qId2 = getQuotationId(requestProject);
            if (qId1 != null && qId2 != null) {
              return String(qId1) === String(qId2);
            }
            return project.ProjectName === requestProject.ProjectName &&
              project.TypeService === requestProject.TypeService;
          }
        )
      );
      return !isMatched;
    });

    setApprovedProjectsManager(updatedProjects);
  }, [
    projects,
    leads,
    LoggedUser,
    assignedProjectsManager,
    ongoingProjectsManager,
    completeProjectsManager,
  ]);

  useEffect(() => {
    const filtered = projects.filter(
      (proj) =>
        Array.isArray(proj.Assignedperson) &&
        proj.Assignedperson.some(
          (person) => person.managerstatus === "project assigned"
        ) &&
        !isProjectLinkedToLostLead(proj, leads)
    );
    const managerProjects = filtered.filter((proj) =>
      proj.Assignedperson?.some(
        (person) => person.email?.toLowerCase() === LoggedUser?.toLowerCase()
      )
    );
    setAssignedProjectsManager(managerProjects);
  }, [projects, LoggedUser, leads]);

  useEffect(() => {
    if (requestedprojects?.length > 0) {
      dispatch(setmytrainingOMProjectRequestState(requestedprojects));
    }
    if (assignedProjectsManager?.length > 0) {
      dispatch(setmytrainingOMProjectAssignedState(assignedProjectsManager));
    }
  }, [requestedprojects, assignedProjectsManager, dispatch]);

  useEffect(() => {
    const filtered = projects.filter(
      (proj) =>
        Array.isArray(proj.Assignedperson) &&
        proj.Assignedperson.some(
          (person) => person.managerstatus === "project ongoing"
        ) &&
        !isProjectLinkedToLostLead(proj, leads)
    );
    const managerProjects = filtered.filter((proj) =>
      proj.Assignedperson?.some(
        (person) => person.email?.toLowerCase() === LoggedUser?.toLowerCase()
      )
    );
    setOngoingProjectsManager(managerProjects);
  }, [projects, LoggedUser, leads]);

  useEffect(() => {
    const filtered = projects.filter(
      (proj) =>
        Array.isArray(proj.Assignedperson) &&
        proj.Assignedperson.some(
          (person) => person.managerstatus === "project complete"
        ) &&
        !isProjectLinkedToLostLead(proj, leads)
    );
    const managerProjects = filtered.filter((proj) =>
      proj.Assignedperson?.some(
        (person) => person.email?.toLowerCase() === LoggedUser?.toLowerCase()
      )
    );
    setCompleteProjectsManager(managerProjects);
  }, [projects, LoggedUser, leads]);

  useEffect(() => {
    if (employeeslist) {
      const filteredList = employeeslist.filter(
        (emp) => emp.EmpEmail !== LoggedUser
      );
      setEmployeesfinalList(filteredList);
    }
  }, [employeeslist, LoggedUser]);

  const handleForward = React.useCallback(
    async (person, selectedValue, index) => {
      setProbabilityList((prev) => {
        const updated = Array.isArray(prev) ? [...prev] : [];
        updated[index] = selectedValue;
        return updated;
      });
      if (
        !assignedPeopleList[index] ||
        assignedPeopleList[index].length === 0
      ) {
        enqueueSnackbar("Please Select employee", {
          variant: "error",
        });
        return;
      }

      const updatedAssignedPersons = (assignedPeopleList[index] || []).map(
        (person) => ({
          ...person,
          manageraction: "forward",
          OpDueDate: requestedprojects[index]?.ProjectDueDate,
        })
      );

      console.log("Gfdhdfj", updatedAssignedPersons);

      // const updatedRow = {
      //   ProjectName: requestedprojects[index]?.ProjectName,
      //   updateData: {
      //     Assignedperson: updatedAssignedPersons,
      //     Attachments: fileNames[index]?.base64
      //       ? [
      //         {
      //           fileName: fileNames[index].name,
      //           file: fileNames[index].base64,
      //         },
      //       ]
      //       : [],
      //     AssignedManagerEmail: requestedprojects[index]?.AssignedManagerEmail, // Optional: default value for manager email

      //   },
      // };

      const assignedIds = updatedAssignedPersons.map((person) => {
        const employee = employees.find((emp) => emp.EmpEmail === person.email);
        return employee ? employee._id : null;
      });

      const selectedProjectId = requestedprojects[index]?._id;
      const selectedUsers = assignedIds;
      const duedate = requestedprojects[index]?.ProjectDueDate;
      SetisLoading(true);
      try {
        await dispatch(
          assignUserToProject({
            projectid: selectedProjectId,
            userids: selectedUsers,
            duedate: duedate,
          })
        );
        enqueueSnackbar("Project Forwarded Successfully", {
          variant: "success",
        });
        SetisLoading(false);
      } catch (error) {
        console.error("Failed to create task:", error);
        SetisLoading(false);
      } finally {
        SetisLoading(false);
        dispatch(fetchAllProjects());
        setAssignedPeopleList({});
        setOpenProbabilityIndex(openProbabilityIndex === index ? null : index);
        setSelectedActionComplete("");
      }
    },
    [
      assignedPeopleList,
      enqueueSnackbar,
      employees,
      requestedprojects,
      SetisLoading,
      dispatch,
      openProbabilityIndex,
      setOpenProbabilityIndex,
    ]
  );

  useEffect(() => {
    if (
      requestedprojects.length > 0 &&
      dateValues.length < requestedprojects.length
    ) {
      const filledDates = requestedprojects.map(() => ({
        requestedDate: null,
        dueDate: null,
      }));
      setDateValues(filledDates);
    }
  }, [requestedprojects, dateValues]);

  const [lastInteractedIndex, setLastInteractedIndex] = useState(null);
  const [wasModified, setWasModified] = useState(false);

  // 2. Update your dropdown interaction handlers to set these states
  const handleDropdownChange = (index) => {
    syncToolGuideStep("assign-employees");
    setLastInteractedIndex(index);
    setWasModified(true);
    // setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };

  const dropdownRefs = useRef({});
  useEffect(() => {
    const handleClickOutside = async (event) => {
      const clickedInsideAnyDropdown = Object.values(dropdownRefs.current).some(
        (ref) => ref && ref.contains(event.target)
      );

      if (
        !clickedInsideAnyDropdown &&
        wasModified &&
        lastInteractedIndex !== null
      ) {
        const selectedPeople = assignedPeopleList[lastInteractedIndex];
        const project = requestedprojects[lastInteractedIndex];

        if (selectedPeople?.length > 0 && project) {
          try {
            await handleForward(selectedPeople, "Forward", lastInteractedIndex);
          } catch (error) {
            console.error("Forward failed:", error);
          }
        }
        setOpenProbabilityIndex(null);
        setOpenDropdownIndex(null);
        setWasModified(false);
        setLastInteractedIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [
    assignedPeopleList,
    wasModified,
    lastInteractedIndex,
    requestedprojects,
    enqueueSnackbar,
    handleForward,
  ]);

  const dropdownRefsProbability = useRef([]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openProbabilityIndex !== null &&
        dropdownRefsProbability.current[openProbabilityIndex] &&
        !dropdownRefsProbability.current[openProbabilityIndex].contains(
          event.target
        )
      ) {
        setOpenProbabilityIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openProbabilityIndex]);

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setshowlogout(false); // Close the popup if clicked outside
    }
  };
  useEffect(() => {
    if (showLogout) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showLogout]);

  const syncManagerToolGuideBucket = (bucketName) => {
    dispatch(setToolGuideRole("L4_PM"));
    dispatch(
      setToolGuideBucket({
        bucketName,
        roleKey: "L4_PM",
        openPanel: true,
      })
    );
  };

  const handleprojectRequest = (projecttype) => {
    handleTabClick("ProjectRequests");
    // setSelectedTab("projectRequest");
    const isOpening = !showprojectrequest;
    setShowprojectrequest(isOpening);
    setShowaproved(false);
    setShowassign(false);
    setShowongoing(false);
    setShowcomplete(false);
    SetShowprojectDetails(false);
    dispatch(fetchAllProjects());
    if (isOpening) {
      dispatch(setActiveBucketName("Project Requests Outstanding"));
      dispatch(setSelectedTabState("projectRequested"));
      syncManagerToolGuideBucket(MANAGER_BUCKET_KEYS.PROJECT_REQUESTS);
    } else {
      dispatch(clearActiveBucketName());
      dispatch(setSelectedTabState(""));
    }
  };

  // After leaving/returning to Project Requests, Self/OP can still look selected
  // while the details panel flag was cleared — remount Effort Expenses when needed.
  useEffect(() => {
    if (!showprojectrequest || !taskTableRowId) return;
    if (isSelf && !managerViewEmpTask) {
      SetShowprojectDetails(true);
      setAction((prev) => (prev === "otherExpenses" || prev === "task" ? prev : "task"));
    }
  }, [showprojectrequest, taskTableRowId, isSelf, managerViewEmpTask]);

  const handleprojectAssign = (projecttype) => {
    const isOpening = !showassign;
    setShowassign(isOpening);
    setShowprojectrequest(false);
    setShowaproved(false);
    setShowongoing(false);
    setShowcomplete(false);
    // setSelectedTab("projectAssign");
    handleTabClick("projectAssign");
    if (isOpening) {
      dispatch(setActiveBucketName("Project Assigned"));
      dispatch(setSelectedTabState("projectAssigned"));
      syncManagerToolGuideBucket(MANAGER_BUCKET_KEYS.PROJECT_ASSIGNED);
    } else {
      dispatch(clearActiveBucketName());
      dispatch(setSelectedTabState(""));
    }
  };
  const handleprojectOngoing = (projecttype) => {
    const isOpening = !showongoing;
    setShowongoing(isOpening);
    setShowassign(false);
    setShowprojectrequest(false);
    setShowaproved(false);
    setShowcomplete(false);
    // setSelectedTab("projectOngoing");
    handleTabClick("projectOngoing");
    if (isOpening) {
      dispatch(setActiveBucketName("Project Ongoing"));
      dispatch(setSelectedTabState("projectOngoing"));
      syncManagerToolGuideBucket(MANAGER_BUCKET_KEYS.PROJECT_ONGOING);
    } else {
      dispatch(clearActiveBucketName());
      dispatch(setSelectedTabState(""));
    }
  };
  const handleprojectCompleted = (projecttype) => {
    const isOpening = !showcomplete;
    setShowcomplete(isOpening);
    setShowongoing(false);
    setShowassign(false);
    setShowprojectrequest(false);
    setShowaproved(false);
    // setSelectedTab("projectCompleted");
    handleTabClick("projectCompleted");
    if (isOpening) {
      dispatch(setActiveBucketName("Project Completed"));
      dispatch(setSelectedTabState("projectCompleted"));
      syncManagerToolGuideBucket(MANAGER_BUCKET_KEYS.PROJECT_COMPLETED);
    } else {
      dispatch(clearActiveBucketName());
      dispatch(setSelectedTabState(""));
    }
  };

  const handleprojectApproved = () => {
    const isOpening = !showaproved;
    setShowaproved(isOpening);
    setShowcomplete(false);
    setShowongoing(false);
    setShowassign(false);
    setShowprojectrequest(false);
    // setSelectedTab("ProjectApproved"); // Change to match handleTabClick
    handleTabClick("ProjectApproved"); // This ensures smooth scrolling too
    if (isOpening) {
      dispatch(setActiveBucketName("Project Approved"));
      dispatch(setSelectedTabState("projectApproved"));
      syncManagerToolGuideBucket(MANAGER_BUCKET_KEYS.PROJECT_APPROVED);
    } else {
      dispatch(clearActiveBucketName());
      dispatch(setSelectedTabState(""));
    }
  };

  const handleFileChange = async (e, projectName, SelectedCategory) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    const maxSize = 2 * 1024 * 1024; // 2MB
    const allowedFormats = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    setFileNames((prev) => {
      const existingFiles = prev[projectName] || [];
      const existingNames = new Set(existingFiles.map((f) => f.name));

      const validFiles = [];

      for (const file of files) {
        // Check type
        if (!allowedFormats.includes(file.type)) {
          enqueueSnackbar(`Only PDF and DOC files are allowed`, {
            variant: "error",
          });
          continue;
        }

        // Check size
        if (file.size > maxSize) {
          enqueueSnackbar(
            `File size exceeds 2MB! Please upload a smaller file.`,
            {
              variant: "error",
            }
          );
          continue;
        }

        // Check duplicate
        if (existingNames.has(file.name)) {
          enqueueSnackbar(`File has already uploaded.`, {
            variant: "error",
          });
          continue;
        }

        validFiles.push(file);
      }

      if (validFiles.length === 0) return prev;

      const updatedFiles = validFiles.map((file) => ({
        name: file.name,
        file,
        uploaded: false,
      }));

      return {
        ...prev,
        [projectName]: [...existingFiles, ...updatedFiles],
      };
    });
  };

  const bufferToUint8Array = (bufferObj) => {
    if (bufferObj?.type === "Buffer" && Array.isArray(bufferObj.data)) {
      return new Uint8Array(bufferObj.data);
    }
    return null;
  };

  const handleFileDelete = (projectName, indexToDelete) => {
    setFileNames((prev) => ({
      ...prev,
      [projectName]: prev[projectName].filter(
        (_, idx) => idx !== indexToDelete
      ),
    }));
    enqueueSnackbar("File Deleted Successfully", {
      variant: "success",
    });
  };

  useEffect(() => {
    const initialMap = {};
    requestedprojects.forEach((project) => {
      const existingFiles =
        project.Attachments?.map((file) => ({
          name: file.fileName,
          id: file?._id,
          uploaded: true,
          file: file.file,
          selectedCategory: file.selectedCategory, // ✅ include buffer object for download
        })) || [];

      initialMap[project.ProjectName] = existingFiles;
    });

    setFileNames(initialMap);
  }, [requestedprojects]);

  const handleDateDueChange = (date, index) => {
    Setrequestedprojects((prevProjects) => {
      const updatedProjects = [...prevProjects];
      const formattedDate = `${date.getFullYear()}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

      updatedProjects[index] = {
        ...updatedProjects[index],
        ProjectDueDate: formattedDate,
      };
      return updatedProjects;
    });
  };
  const [popupProject, setPopupProject] = useState(null); // e.g. "Project A"
  const totalHours = rows.reduce(
    (sum, row) => sum + Number(row.hoursassigned || 0),
    0
  );

  // When initializing rows or setting from API data
  const initializeRows = useCallback((workEntries) => {
    return workEntries.map((entry) => ({
      ...entry,
      frontendId: entry.frontendId || generateId(),
    }));
  }, []);

  const rowsSyncKeyRef = useRef(null);

  useEffect(() => {
    const syncKey = `${managerSelectedEmpOnChange?._id ?? ""}|${selectedselfemail ?? ""}`;
    if (rowsSyncKeyRef.current === syncKey) {
      return;
    }
    rowsSyncKeyRef.current = syncKey;

    if (managerSelectedEmpOnChange?.WorkEntries?.length > 0) {
      const filteredEntries = managerSelectedEmpOnChange.WorkEntries.filter(
        (entry) => entry.createdBy?.email === selectedselfemail
      );

      if (filteredEntries.length > 0) {
        setRows(initializeRows(filteredEntries));
      } else {
        setRows([
          { task: "", hoursassigned: "", notes: "", frontendId: generateId() },
        ]);
      }
    } else {
      setRows([
        { task: "", hoursassigned: "", notes: "", frontendId: generateId() },
      ]);
    }
  }, [managerSelectedEmpOnChange, initializeRows, selectedselfemail]);

  // Simple ID generator
  const generateId = () => Math.random().toString(36).substr(2, 9);

  const handleAddRow = () => {
    if (rows.length < 15) {
      setRows((prev) => [...prev, { task: "", hoursassigned: "", notes: "" }]);
    } else {
      enqueueSnackbar("You can only add up to 15 rows.", { variant: "error" });
    }
  };
  const handleRemoveRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

  const handleAddRowManagerEdit = () => {
    if (rowsManager.length < 15) {
      // Get CreatedBy from the first existing row (or fallback to current user if needed)
      const baseRow = rowsManager[0] || {}; // use first row as reference

      setRowsManager([
        ...rowsManager,
        {
          task: "",
          hoursassigned: "",
          notes: "",
          startdate: new Date().toISOString(), // Default to today
          createdBy: baseRow.createdBy, // 👈 preserve or set CreatedBy
        },
      ]);
    } else {
      enqueueSnackbar("You can only add up to 15 rows.", { variant: "error" });
    }
  };

  const handleCompleteself = (row) => {
    syncToolGuideStep("complete");
    Setshowselfcompletepopup(true);
    setselfcompleterow(row);
  };

  // Response Received reads workentries. Backend /submit-task skips delete when autosave is empty,
  // so clear stale workentries here when the manager completed with no current effort rows.
  const clearStaleWorkentriesIfAutosaveEmpty = async (projectId, personId) => {
    if (!projectId || !personId) return;
    const hasAutosave = (autosaveentries || []).some(
      (entry) =>
        String(entry.projectid) === String(projectId) &&
        String(entry.taskownerid) === String(personId) &&
        entry.isProjecttracking !== true
    );
    if (hasAutosave) return;
    const staleIds = (entries || [])
      .filter(
        (entry) =>
          String(entry.projectid) === String(projectId) &&
          String(entry.taskownerid) === String(personId) &&
          entry.isProjecttracking !== true
      )
      .map((entry) => entry._id)
      .filter(Boolean);
    if (staleIds.length === 0) return;
    await dispatch(deleteTask(staleIds));
    await dispatch(fetchWorkEntries());
  };

  const handleComplete = async (row) => {
    syncToolGuideStep("complete");
    Setshowselfcompletepopup(false);
    const email = localStorage.getItem("email"); // "yapew30764@miracle3.com"
    const name = localStorage.getItem("name");
    const lastName = localStorage.getItem("lastName");
    const assignPersonmain = name + " " + lastName;

    const filteredEmployee = employees.find((emp) => emp.EmpEmail === email);
    const updatedRow = {
      ProjectName: row.ProjectName,
      ProjectDueDate: row.ProjectDueDate,
      ProjectManagerStatus: row.ProjectManagerStatus,
      updateData: {
        AssignedManagerEmail: row.AssignedManagerEmail,
        Assignedperson: [
          {
            name: assignPersonmain,
            email: email,
            salespersonstatus: "response received",
            taskStatus: "submit",
          },
        ],
      },
    };

    const formData = new FormData();
    formData.append("project", JSON.stringify(updatedRow)); // ✅

    const payload = {
      projectId: row?._id,
      personId: filteredEmployee?._id,
    };

    SetisLoading(true);
    try {
      await clearStaleWorkentriesIfAutosaveEmpty(row?._id, filteredEmployee?._id);
      await dispatch(updateManagerAction(payload));
      enqueueSnackbar("Project Completed Successfully", { variant: "success" });
    } catch (error) {
      console.error("Failed to create task:", error);
    } finally {
      SetisLoading(false);
      handlerefresh();
    }
    dispatch(fetchAllProjects());
    setProbabilityList({});
    setselectedAction("");
  };

  const handleCompletesubmit = () => {
    Setshowcompletepopup(false);
    HandleCompleted(showcompleteperson, showcompleteproject);
  };
  const [selectedActions, setSelectedActions] = useState({});

  const [selectedActionComplete, setSelectedActionComplete] = useState("");

  const handleManagerAction = async (action, person, rowproject) => {
    const Name = person.name;
    if (action === "complete") {
      syncToolGuideStep("complete");
      Setshowcompletepopup(true);
      Setshowcompleteperson(person);
      Setshowcompleteproject(rowproject);

      // HandleCompleted(person, rowproject);
    } else if (action === "reminder") {
      HandleReminder(Name, rowproject);
    } else if (action === "cancel") {
      setSelectedActionComplete("");

      HandleCancel(person, rowproject);
    } else if (action === "review") {
      HandleReview(Name, rowproject);
    } else if (action === "reassign") {
      HandleReassign(Name, rowproject);
    }
  };

  const handleselfcancel = (row) => {
    const email = localStorage.getItem("email"); // "yapew30764@miracle3.com"
    const name = localStorage.getItem("name");
    const lastName = localStorage.getItem("lastName");
    const assignPersonmain = name + " " + lastName;
    const filteredEmployee = employees.find((emp) => emp.EmpEmail === email);
    const rowproject = row;
    const person = {
      name: assignPersonmain,
      email: email,
      manageraction: "cancel",
      _id: filteredEmployee?._id,
    };
    HandleCancel(person, rowproject);
  };

  const handleselfreview = async (row) => {
    const email = localStorage.getItem("email");
    const filteredEmployee = employees.find((emp) => emp.EmpEmail === email);
    SetisLoading(true);
    try {
      await dispatch(
        managerActionRecall({
          projectid: row._id,
          personid: filteredEmployee?._id,
        })
      );
    } catch (error) {
      console.error("Failed to create task:", error);
      SetisLoading(false);
    } finally {
      SetisLoading(false);
      dispatch(fetchAllProjects());
      setTaskTableRowId(null);
      setSelectedSelfAction(""); // Reset selectedSelfAction after API call
      handlerefresh();
      handlerefreshagain();
      setIsSelfChecke(false);
    }
  };

  const HandleReassign = async (Name, rowproject) => {
    const updatedAssignedperson = (rowproject.Assignedperson || [])
      .filter((person) => person.name === Name)
      .map((person) => ({
        ...person,
        manageraction: "reassign",
        operationaction: "",
        taskStatus: "pending",
        isRead: true,
      }));

    const filteredEmployee = employees.find(
      (emp) => emp?.EmpEmail === updatedAssignedperson[0]?.email
    );

    const selectedProjectId = rowproject?._id;
    const selectedUserId = filteredEmployee?._id;

    SetisLoading(true);
    try {
      await dispatch(
        operationActionReassign({
          projectid: selectedProjectId,
          userid: selectedUserId,
        })
      ).unwrap();

      enqueueSnackbar("Project Re-assigned Successfully", {
        variant: "success",
      });
      SetisLoading(false);
    } catch (error) {
      console.error("Failed to create task:", error);
      SetisLoading(false);
    } finally {
      SetisLoading(false);
    }

    dispatch(fetchAllProjects());
  };

  const HandleCompleted = async (person, rowproject) => {
    syncToolGuideStep("complete");
    const filteredEmployee = employees.find(
      (emp) => emp.EmpEmail === person.email
    );
    const updatedAssignedperson = (rowproject.Assignedperson || [])
      .filter((persons) => persons.name === person.name)
      .map((persons) => ({
        ...persons,
        salespersonstatus: "response received",
        taskStatus: "submit",
      }));
    const updatedRow = {
      ProjectName: rowproject.ProjectName,
      updateData: {
        Assignedperson: updatedAssignedperson,
        AssignedManagerEmail: rowproject.AssignedManagerEmail,
      },
    };
    const formData = new FormData();
    formData.append("project", JSON.stringify(updatedRow));
    const payload = {
      projectId: rowproject?._id,
      personId: filteredEmployee?._id,
    };
    SetisLoading(true);
    try {
      await clearStaleWorkentriesIfAutosaveEmpty(
        rowproject?._id,
        filteredEmployee?._id
      );
      await dispatch(updateManagerAction(payload));
      enqueueSnackbar("Project Completed Successfully", {
        variant: "success",
      });
    } catch (error) {
      console.error("Failed to create task:", error);
    } finally {
      SetisLoading(false);
      dispatch(fetchAllProjects());
      Setshowcompleteproject("");
      Setshowcompleteperson("");
      setSelectedActionComplete("");
    }
  };

  const HandleReminder = async (Name, rowproject) => {
    const updatedAssignedperson = (rowproject.Assignedperson || [])
      .filter((person) => person.name === Name)
      .map((person) => ({
        ...person,
        manageraction: "reminder",
      }));
    const filteredEmployee = employees.find(
      (emp) => emp?.EmpEmail === updatedAssignedperson[0]?.email
    );
    SetisLoading(true);
    try {
      await dispatch(
        handleProjectAction({
          projectid: rowproject?._id,
          userid: filteredEmployee?._id,
          action: "reminder",
        })
      );
      enqueueSnackbar("Project Reminder Sent Successfully", {
        variant: "success",
      });
      SetisLoading(false);
    } catch (error) {
      console.error("Failed to create task:", error);
      SetisLoading(false);
    } finally {
      SetisLoading(false);
    }

    dispatch(fetchAllProjects());
  };
  const HandleCancel = async (person, rowproject) => {
    const targetPerson = employees?.find(
      (employee) => employee.EmpEmail === person.email
    );
    const projectid = rowproject?._id;
    const personid = targetPerson ? targetPerson?._id : null;
    SetisLoading(true);
    try {
      await dispatch(cancelPersonFromProject({ projectid, personid }));
      enqueueSnackbar("Employee Cancelled Successfully", {
        variant: "success",
      });
      SetisLoading(false);
    } catch (error) {
      console.error("Failed to create task:", error);
      SetisLoading(false);
    } finally {
      SetisLoading(false);
      setTaskTableRowId(null);
      handlerefresh();
      handlerefreshagain();
    }
    dispatch(fetchAllProjects());
  };

  const HandleReview = async (Name, rowproject) => {
    const updatedAssignedperson = (rowproject.Assignedperson || [])
      .filter((person) => person.name === Name)
      .map((person) => ({
        ...person,
        manageraction: "review",
        taskStatus: "review",
        isRead: true,
      }));
    const filteredEmployee = employees.find(
      (emp) => emp?.EmpEmail === updatedAssignedperson[0]?.email
    );
    SetisLoading(true);
    try {
      await dispatch(
        handleProjectAction({
          projectid: rowproject?._id,
          userid: filteredEmployee?._id,
          action: "review",
        })
      );
      enqueueSnackbar("Project Sent to Review Successfully", {
        variant: "success",
      });
      SetisLoading(false);
    } catch (error) {
      console.error("Failed to create task:", error);
      SetisLoading(false);
    } finally {
      SetisLoading(false);
    }
    dispatch(fetchAllProjects());
  };

  const [activeDropdownId, setActiveDropdownId] = useState(null);

  const handleMenuToggle = (rowId, person) => {
    if (person.operationaction === "reject") return;

    const id = `${rowId}_${person.email}`;
    setActiveDropdownId((prev) => (prev === id ? null : id));
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdownId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleReject = async (row) => {
    SetisLoading(true);
    try {
      await dispatch(projectAction({ projectid: row._id, action: "reject" }));
      enqueueSnackbar("Project Rejected Successfully", {
        variant: "success",
      });
      setRows([emptyRow]);
    } catch (error) {
      console.error("Failed to create task:", error);
    } finally {
      SetisLoading(false);
    }
    dispatch(fetchAllProjects());
  };

  useEffect(() => {
    requestedprojects.forEach((project, index) => {
      if (project.Assignedperson?.length > 0) {
        setProject((prev) => ({ ...prev, [index]: project }));
      }
    });
  }, [requestedprojects]);

  const [managerProject, setManagerProject] = useState([]);

  useEffect(() => {
    setManagerProject(requestedprojects); // initial fill or refetch
    // setCurrentPage(1); // start from page 1
  }, [requestedprojects]);

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const [itemsPerPage] = useState(10);

  const totalItems = managerProject.length;
  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;

  // Function to calculate the number of pages
  const totalPages = Math.ceil(managerProject.length / itemsPerPage);

  // Slice the filteredLeadReport based on the current page
  const currentData = managerProject.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  console.log("managerassignment currentData", currentData);
  const handleSearchInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    filterLeadReports(query);
    setCurrentPage(1);
  };

  const filterLeadReports = (query) => {
    const lowerCaseQuery = query?.toLowerCase().trim();

    const filtered = requestedprojects.filter((LeadReport) =>
      getDisplayGroupName(LeadReport).toLowerCase().includes(lowerCaseQuery) ||
      Object.entries(LeadReport).some(([key, value]) => {
        // Skip these keys
        if (
          key === "Assignedperson" ||
          key === "TypeService" ||
          key === "SalesPersonName" ||
          key === "SalesPersonEmail" ||
          key === "ResourceType" ||
          key === "QuotedValue" ||
          key === "ProjectManagerStatus" ||
          key === "ProjectManagerAction" ||
          key === "createdAt" ||
          key === "updatedAt" ||
          key === "PrimaryResources"
        )
          return false;

        if (value === null || value === undefined) return false;
        if (key === "DateRequested" || key === "ProjectDueDate") {
          const formattedDate = formatDateByCountry(value); // ← change here
          return formattedDate?.toLowerCase()?.includes(lowerCaseQuery);
        }

        // Handle all other fields
        const formattedValue = value?.toString()?.trim()?.toLowerCase();
        return formattedValue?.includes(lowerCaseQuery);
      })
    );

    setManagerProject(filtered);
  };

  const sortAlphabetically = (targetToSort, order) => {
    const key = `${targetToSort}-${order}`;

    // Create a deep copy of the current data to avoid mutating state directly
    const sorted = [...managerProject];

    // Helper function for case-insensitive comparison
    const compareStrings = (a, b) => {
      const valA = (a || "").toString()?.toLowerCase();
      const valB = (b || "").toString()?.toLowerCase();
      return valA.localeCompare(valB);
    };

    // Helper function for date comparison
    const compareDates = (a, b) => {
      const dateA = a ? new Date(a) : null;
      const dateB = b ? new Date(b) : null;

      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;

      return dateA - dateB;
    };

    switch (key) {
      case "AssignedGroup-az":
        sorted.sort((a, b) =>
          compareStrings(getDisplayGroupName(a), getDisplayGroupName(b))
        );
        break;
      case "AssignedGroup-za":
        sorted.sort((a, b) =>
          compareStrings(getDisplayGroupName(b), getDisplayGroupName(a))
        );
        break;
      case "ProjectName-az":
        sorted.sort((a, b) => compareStrings(a.ProjectName, b.ProjectName));
        break;
      case "ProjectName-za":
        sorted.sort((a, b) => compareStrings(b.ProjectName, a.ProjectName));
        break;
      case "DateRequested-az":
        sorted.sort((a, b) => compareDates(a.DateRequested, b.DateRequested));
        break;
      case "DateRequested-za":
        sorted.sort((a, b) => compareDates(b.DateRequested, a.DateRequested));
        break;
      case "ProjectDueDate-az":
        sorted.sort((a, b) => compareDates(a.ProjectDueDate, b.ProjectDueDate));
        break;
      case "ProjectDueDate-za":
        sorted.sort((a, b) => compareDates(b.ProjectDueDate, a.ProjectDueDate));
        break;
      default:
        // No sorting needed
        break;
    }
    setManagerProject(sorted);
    setCurrentPage(1); // Reset to first page after sorting
  };

  const handleforwardself = async (row) => {
    syncToolGuideStep("assign-employees");
    const email = localStorage.getItem("email"); // "yapew30764@miracle3.com"
    const userAlreadyAssigned = row.Assignedperson?.some(
      (person) => person.email === email
    );

    if (userAlreadyAssigned) {
      return;
    }
    const employee = employees.find((emp) => emp.EmpEmail === email);
    const selectedProjectId = row?._id;
    const selectedUsers = [employee?._id];
    const duedate = row?.ProjectDueDate;
    SetisLoading(true);
    try {
      await dispatch(
        assignUserToProject({
          projectid: selectedProjectId,
          userids: selectedUsers,
          duedate: duedate,
        })
      );
      enqueueSnackbar("self forwared Successfully.", {
        variant: "success",
      });
    } catch (error) {
      console.error("Operation failed:", error);
    } finally {
      SetisLoading(false);
      dispatch(fetchAllProjects());
    }
  };

  useEffect(() => {
    if (projectTrackingWorkEntries?.length && ongoingProjectsManager?.length) {
      const ongoingProjectIds = ongoingProjectsManager.map(
        (project) => project?._id
      );
      const filtered = projectTrackingWorkEntries.filter((entry) => {
        const matchesProject = ongoingProjectIds.includes(entry.projectid);
        return matchesProject;
      });
      const hardwareParts = hardwareProjectTracking.filter((entry) => {
        const matchesProject = ongoingProjectIds.includes(entry.projectid);
        return matchesProject;
      });
      setongoingEntries(filtered);
      setongoingHardwareParts(hardwareParts);
    } else {
      setongoingEntries([]);
    }
  }, [
    projectTrackingWorkEntries,
    employees,
    ongoingProjectsManager,
    hardwareProjectTracking,
  ]);

  const [selected, setSelected] = useState(false);

  useEffect(() => {
    if (
      (selected || showprojectDetails || taskTableRowId) &&
      ProjectRequestRef.current
    ) {
      // Scroll to the right end of the container
      const scrollToPosition = ProjectRequestRef.current.scrollWidth;
      ProjectRequestRef.current.scrollTo({
        left: scrollToPosition,
        behavior: "smooth",
      });
    }
  }, [
    selected,
    expandedRowId,
    showprojectDetails,
    taskTableRowId,
    managerViewEmpTask,
  ]);

  const [loggedEmp, setLoggedEmp] = useState({});

  useEffect(() => {
    const Email = localStorage.getItem("email");
    const loggedEmp = employees?.find((emp) => emp?.EmpEmail === Email);
    setLoggedEmp(loggedEmp);
  }, [employees]);

  const handleleadread = async (row) => {
    const projectId = row._id;
    try {
      await dispatch(setProjectReadTrue(projectId));
    } catch (error) {
      console.error("Failed to create task:", error);
    } finally {
    }
    dispatch(fetchAllProjects());
  };

  return (
    <>
      {isLoading ? <AdminLoader isLoading={isLoading} /> : <> </>}
      <div className="">
        <div className={`w-full flex ${showHardwareLayout ? "gap-5" : "gap-1"} min-h-[20rem] justify-center pb-0.1 mt-1`}>
          {showHardwareLayout && canShowCard("MY PROJECTS") && (
            <div className="border-gray-400 w-[33%]">
              <ManagerMyProjects
                filteredOngoingProjects={filteredOngoingProjects}
                filteredOngoingEntries={filteredOngoingEntries}
              />
            </div>
          )}
          {!showHardwareLayout && (canShowCard("MY PROJECTS") ||
            canShowCard("APPROVED HRS")) && (
              <div
                className={`border-gray-400 ${canShowCard("MY PROJECTS") &&
                  !canShowCard("APPROVED HRS")
                  ? "w-[25%]"
                  : !canShowCard("MY PROJECTS") &&
                    canShowCard("APPROVED HRS")
                    ? "w-[25%]"
                    : canShowCard("MY PROJECTS") &&
                      canShowCard("APPROVED HRS")
                      ? "w-[50%]"
                      : ""
                  } `}
              >
                <ManagerMyProjects
                  filteredOngoingProjects={filteredOngoingProjects}
                  filteredOngoingEntries={filteredOngoingEntries}
                />
              </div>
            )}
          {canShowCard("PRODUCTIVITY") && (
            <div className={`border-gray-400 ${showHardwareLayout ? "w-[33%]" : "w-[25%] xl:w-[25%]"}`}>
              <SpeedometerGraph ongoingEntries={filteredOngoingEntries} />
            </div>
          )}
          {!showHardwareLayout && canShowCard("PROJECTS & TIME ENTRIES") && (
              <div className="border-gray-400 w-[25%] xl:w-[25%]">
                <TimeEntriesGraph
                  ongoingProjectsManager={filteredOngoingProjects}
                  filteredOngoingEntries={filteredOngoingEntries}
                />
                {/* <TimeEntriesGraph ongoingProjectsManager={ongoingProjectsManager} ongoingEntries={ongoingEntries} /> */}
              </div>
            )}
          {showHardwareLayout && canShowCard("MY REQUEST") && (
            emp === "manager" ? (
              <div id="my-requests-section" className="w-[33%] relative bg-white rounded-md pl-2 pr-2">
                <div className="mt-3">
                  <div className="bg-[#e8e8e8] border border-gray-400 text-black text-center py-2 rounded-t-lg font-semibold">
                    My Requests
                  </div>
                  <div className="flex w-full pt-5 p-2">
                    <div
                      className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px]  cp:h-[480px] w-[20%] items-center"

                    >
                      <div className="w-[20%] flex justify-center">
                        <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
                          Project Requests
                        </p>
                      </div>
                      <div
                        onClick={() => {
                          handleprojectRequest("projectRequest");
                        }}
                        className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${showprojectrequest
                          ? "bg-blue-900 border-[#3a1e0a] shadow-lg"
                          : "bg-[#4e95d9] border-[#5A3D2B]"
                          }`}
                        style={{ borderColor: "#5A3D2B" }}
                      >
                        {unreadleadcountrequest.length > 0 && (
                          <div className="absolute top-3 flex justify-center align-middle items-center">
                            <span className=" opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                              {unreadleadcountrequest.length}
                            </span>
                          </div>
                        )}
                        <span
                          className={`text-white ${unreadleadcountrequest.length > 0
                            ? "text-2xl font-semibold"
                            : "text-lg"
                            } font-semibold`}
                        >
                          {requestedprojects.length}
                        </span>
                        {showprojectrequest && (
                          <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
                        )}
                      </div>
                    </div>
                    <div
                      className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px]  cp:h-[480px] w-[20%] items-center"

                    >
                      <div className="w-[20%] flex justify-center">
                        <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
                          Project Approved
                        </p>
                      </div>
                      <div
                        onClick={() => {
                          handleprojectApproved();
                        }}
                        className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${showaproved
                          ? "bg-yellow-600 border-[#3a1e0a] shadow-lg"
                          : "bg-[#ffc000] border-[#5A3D2B]"
                          }`}
                        style={{ borderColor: "#5A3D2B" }}
                      >
                        {unreadleadcountapproved.length > 0 && (
                          <div className="absolute top-3 flex justify-center align-middle items-center">
                            <span className="  opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                              {unreadleadcountapproved.length}
                            </span>
                          </div>
                        )}
                        <span
                          className={`text-white ${unreadleadcountapproved.length > 0
                            ? "text-2xl font-semibold"
                            : "text-lg"
                            } `}
                        >
                          {approvedProjectsManager?.length}
                        </span>
                        {showaproved && (
                          <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
                        )}
                      </div>
                    </div>
                    <div
                      className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px]  cp:h-[480px] w-[20%] items-center"

                    >
                      <div className="w-[20%] flex justify-center">
                        <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
                          Project Assigned
                        </p>
                      </div>
                      <div
                        onClick={() => {
                          handleprojectAssign();
                        }}
                        className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${showassign
                          ? "bg-yellow-800 border-[#3a1e0a] shadow-lg"
                          : "bg-[#cfb053] border-[#5A3D2B]"
                          }`}
                        style={{ borderColor: "#5A3D2B" }}
                      >
                        {unreadleadcountassign.length > 0 && (
                          <div className="absolute top-3 flex justify-center align-middle items-center">
                            <span className="opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                              {unreadleadcountassign.length}
                            </span>
                          </div>
                        )}
                        <span
                          className={`text-white ${unreadleadcountassign.length > 0
                            ? "text-2xl font-semibold"
                            : "text-lg"
                            }`}
                        >
                          {assignedProjectsManager.length}
                        </span>
                        {showassign && (
                          <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
                        )}
                      </div>
                    </div>
                    <div
                      className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px]  cp:h-[480px] w-[20%] items-center"

                    >
                      <div className="w-[20%] flex justify-center">
                        <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
                          Project Ongoing
                        </p>
                      </div>
                      <div
                        onClick={() => {
                          handleprojectOngoing();
                        }}
                        className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${showongoing
                          ? "bg-[#D27D2D] border-[#3a1e0a] shadow-lg"
                          : "bg-yellow-700 border-[#5A3D2B]"
                          }`}
                        style={{ borderColor: "#5A3D2B" }}
                      >
                        {unreadleadcountongoing.length > 0 && (
                          <div className="absolute top-3 flex justify-center align-middle items-center">
                            <span className="opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                              {unreadleadcountongoing.length}
                            </span>
                          </div>
                        )}
                        <span
                          className={`text-white ${unreadleadcountongoing.length > 0
                            ? " text-2xl font-semibold"
                            : "text-lg"
                            }`}
                        >
                          {ongoingProjectsManager.length}
                        </span>
                        {showongoing && (
                          <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
                        )}
                      </div>
                    </div>
                    <div
                      className="flex h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px]  cp:h-[480px] w-[20%] items-center"

                    >
                      <div className="w-[20%] flex justify-center">
                        <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
                          Project Completed
                        </p>
                      </div>
                      <div
                        onClick={() => {
                          handleprojectCompleted();
                        }}
                        className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${selectedTab === "projectCompleted"
                          ? "bg-green-600 border-[#3a1e0a] shadow-lg"
                          : "bg-[#47d45a] border-[#5A3D2B]"
                          }`}
                        style={{ borderColor: "#5A3D2B" }}
                      >
                        {unreadleadcountcomplete.length > 0 && (
                          <div className="absolute top-3 flex justify-center align-middle items-center">
                            <span className=" opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                              {unreadleadcountcomplete.length}
                            </span>
                          </div>
                        )}
                        <span
                          className={`text-white ${unreadleadcountongoing.length > 0
                            ? " text-2xl font-semibold"
                            : "text-lg"
                            }`}
                        >
                          {completeProjectsManager.length}
                        </span>
                        {selectedTab === "projectCompleted" && (
                          <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
                        )}
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            ) : (
              <>
                <OPMyRequestPM
                  EmpEmail={EmpEmail}
                  setShowprojectrequestPM={setShowprojectrequestPM}
                  setShowaprovedPM={setShowaprovedPM}
                  setShowassignPM={setShowassignPM}
                  setShowongoingPM={setShowongoingPM}
                  setShowcompletePM={setShowcompletePM}
                  showprojectrequestPM={showprojectrequestPM}
                  showaprovedPM={showaprovedPM}
                  showassignPM={showassignPM}
                  showongoingPM={showongoingPM}
                  showcompletePM={showcompletePM}
                  SetrequestedprojectsDataPM={SetrequestedprojectsDataPM}
                  setApprovedProjectsManagerDataPM={setApprovedProjectsManagerDataPM}
                  setAssignedProjectsManagerDataPM={setAssignedProjectsManagerDataPM}
                  setOngoingProjectsManagerDataPM={setOngoingProjectsManagerDataPM}
                  setCompleteProjectsManagerDataPM={setCompleteProjectsManagerDataPM}
                  setProjectsRequestDataPM={setProjectsRequestDataPM}
                  requestedprojectsDataPM={requestedprojectsDataPM}
                  approvedProjectsManagerDataPM={approvedProjectsManagerDataPM}
                  assignedProjectsManagerDataPM={assignedProjectsManagerDataPM}
                  ongoingProjectsManagerDataPM={ongoingProjectsManagerDataPM}
                  completeProjectsManagerDataPM={completeProjectsManagerDataPM}
                  projectsRequestDataPM={projectsRequestDataPM}
                />
              </>
            )
          )}
        </div>


        {/* For non-hardware managers, show second row with MY REQUEST, TASK IN HAND, UTILISATION REPORT */}
        {!showHardwareLayout && (
          <div className="w-full flex gap-1 pt-2">
            {canShowCard("MY REQUEST") && (
            emp === "manager" ? (
              <div id="my-requests-section" className="w-[40%]  relative bg-white rounded-md pl-2 pr-2">
                <div className="mt-3">
                  <div className="bg-[#e8e8e8] border border-gray-400 text-black text-center py-2 rounded-t-lg font-semibold">
                    My Requests
                  </div>
                  <div className="flex w-full pt-5 p-2">
                    <div
                      className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px]  cp:h-[480px] w-[20%] items-center"

                    >
                      <div className="w-[20%] flex justify-center">
                        <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
                          Project Requests
                        </p>
                      </div>
                      <div
                        onClick={() => {
                          handleprojectRequest("projectRequest");
                        }}
                        className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${showprojectrequest
                          ? "bg-blue-900 border-[#3a1e0a] shadow-lg"
                          : "bg-[#4e95d9] border-[#5A3D2B]"
                          }`}
                        style={{ borderColor: "#5A3D2B" }}
                      >
                        {unreadleadcountrequest.length > 0 && (
                          <div className="absolute top-3 flex justify-center align-middle items-center">
                            {/* <NotificationsActiveIcon
                          className="text-black w-6 h-6"
                        /> */}
                            <span className=" opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                              {unreadleadcountrequest.length}
                            </span>
                          </div>
                        )}

                        <span
                          className={`text-white ${unreadleadcountrequest.length > 0
                            ? "text-2xl font-semibold"
                            : "text-lg"
                            } font-semibold`}
                        >
                          {requestedprojects.length}
                        </span>
                        {showprojectrequest && (
                          <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
                        )}
                      </div>
                    </div>
                    <div
                      className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px]  cp:h-[480px] w-[20%] items-center"

                    >
                      <div className="w-[20%] flex justify-center">
                        <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
                          Project Approved
                        </p>
                      </div>

                      <div
                        onClick={() => {
                          handleprojectApproved();
                        }}
                        className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${showaproved
                          ? "bg-yellow-600 border-[#3a1e0a] shadow-lg"
                          : "bg-[#ffc000] border-[#5A3D2B]"
                          }`}
                        style={{ borderColor: "#5A3D2B" }}
                      >
                        {unreadleadcountapproved.length > 0 && (
                          <div className="absolute top-3 flex justify-center align-middle items-center">
                            {/* <NotificationsActiveIcon
                          className="text-black w-6 h-6"
                        /> */}
                            <span className="  opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                              {unreadleadcountapproved.length}
                            </span>
                          </div>
                        )}

                        <span
                          className={`text-white ${unreadleadcountapproved.length > 0
                            ? "text-2xl font-semibold"
                            : "text-lg"
                            } `}
                        >
                          {approvedProjectsManager?.length}
                        </span>
                        {showaproved && (
                          <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
                        )}
                      </div>
                    </div>
                    <div
                      className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px]  cp:h-[480px] w-[20%] items-center"

                    >
                      <div className="w-[20%] flex justify-center">
                        <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
                          Project Assigned
                        </p>
                      </div>

                      <div
                        onClick={() => {
                          handleprojectAssign();
                        }}
                        className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${showassign
                          ? "bg-yellow-800 border-[#3a1e0a] shadow-lg"
                          : "bg-[#cfb053] border-[#5A3D2B]"
                          }`}
                        style={{ borderColor: "#5A3D2B" }}
                      >
                        {unreadleadcountassign.length > 0 && (
                          <div className="absolute top-3 flex justify-center align-middle items-center">
                            {/* <NotificationsActiveIcon
                          className="text-black w-6 h-6"
                        /> */}
                            <span className="opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                              {unreadleadcountassign.length}
                            </span>
                          </div>
                        )}
                        <span
                          className={`text-white ${unreadleadcountassign.length > 0
                            ? "text-2xl font-semibold"
                            : "text-lg"
                            }`}
                        >
                          {assignedProjectsManager.length}
                        </span>
                        {showassign && (
                          <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
                        )}
                      </div>
                    </div>
                    <div
                      className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px]  cp:h-[480px] w-[20%] items-center"

                    >
                      <div className="w-[20%] flex justify-center">
                        <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
                          Project Ongoing
                        </p>
                      </div>

                      <div
                        onClick={() => {
                          handleprojectOngoing();
                        }}
                        className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${showongoing
                          ? "bg-[#D27D2D] border-[#3a1e0a] shadow-lg"
                          : "bg-yellow-700 border-[#5A3D2B]"
                          }`}
                        style={{ borderColor: "#5A3D2B" }}
                      >
                        {unreadleadcountongoing.length > 0 && (
                          <div className="absolute top-3 flex justify-center align-middle items-center">
                            {/* <NotificationsActiveIcon
                          className="text-black w-6 h-6"
                        /> */}
                            <span className="opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                              {unreadleadcountongoing.length}
                            </span>
                          </div>
                        )}
                        <span
                          className={`text-white ${unreadleadcountongoing.length > 0
                            ? " text-2xl font-semibold"
                            : "text-lg"
                            }`}
                        >
                          {ongoingProjectsManager.length}
                        </span>
                        {showongoing && (
                          <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
                        )}
                      </div>
                    </div>
                    <div
                      className="flex h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px]  cp:h-[480px] w-[20%] items-center"

                    >
                      <div className="w-[20%] flex justify-center">
                        <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
                          Project Completed
                        </p>
                      </div>

                      <div
                        onClick={() => {
                          handleprojectCompleted();
                        }}
                        className={`relative flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer ${selectedTab === "projectCompleted"
                          ? "bg-green-600 border-[#3a1e0a] shadow-lg"
                          : "bg-[#47d45a] border-[#5A3D2B]"
                          }`}
                        style={{ borderColor: "#5A3D2B" }}
                      >
                        {unreadleadcountcomplete.length > 0 && (
                          <div className="absolute top-3 flex justify-center align-middle items-center">
                            {/* <NotificationsActiveIcon
                          className="text-black w-6 h-6"
                        /> */}
                            <span className=" opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                              {unreadleadcountcomplete.length}
                            </span>
                          </div>
                        )}
                        <span
                          className={`text-white ${unreadleadcountongoing.length > 0
                            ? " text-2xl font-semibold"
                            : "text-lg"
                            }`}
                        >
                          {completeProjectsManager.length}
                        </span>
                        {selectedTab === "projectCompleted" && (
                          <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
                        )}
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            ) : (
              <>
                <OPMyRequestPM
                  EmpEmail={EmpEmail}
                  setShowprojectrequestPM={setShowprojectrequestPM}
                  setShowaprovedPM={setShowaprovedPM}
                  setShowassignPM={setShowassignPM}
                  setShowongoingPM={setShowongoingPM}
                  setShowcompletePM={setShowcompletePM}
                  showprojectrequestPM={showprojectrequestPM}
                  showaprovedPM={showaprovedPM}
                  showassignPM={showassignPM}
                  showongoingPM={showongoingPM}
                  showcompletePM={showcompletePM}
                  SetrequestedprojectsDataPM={SetrequestedprojectsDataPM}
                  setApprovedProjectsManagerDataPM={setApprovedProjectsManagerDataPM}
                  setAssignedProjectsManagerDataPM={setAssignedProjectsManagerDataPM}
                  setOngoingProjectsManagerDataPM={setOngoingProjectsManagerDataPM}
                  setCompleteProjectsManagerDataPM={setCompleteProjectsManagerDataPM}
                  setProjectsRequestDataPM={setProjectsRequestDataPM}
                  requestedprojectsDataPM={requestedprojectsDataPM}
                  approvedProjectsManagerDataPM={approvedProjectsManagerDataPM}
                  assignedProjectsManagerDataPM={assignedProjectsManagerDataPM}
                  ongoingProjectsManagerDataPM={ongoingProjectsManagerDataPM}
                  completeProjectsManagerDataPM={completeProjectsManagerDataPM}
                  projectsRequestDataPM={projectsRequestDataPM}
                />
              </>
            )
          )}

          {canShowCard("TASK IN HAND") && (
            <div className="w-[25%]">
              <TaskInHand
                ongoingEntries={filteredOngoingEntries}
                ongoingOpProjectsState={filteredOngoingProjects}
                ongoingHardwareParts={filteredOngoingHardwareParts}
                isInteractionDisabled={isViewOnlyTaskInHand}
                isViewOnly={isViewOnlyTaskInHand}
              />
            </div>
          )}

          {canShowCard("UTILISATION REPORT") && (
            <div className="w-[35%]">
              <UtilizationReport
                ongoingProjectsManager={filteredOngoingProjects}
                ongoingEntries={filteredOngoingEntries}
                User={"Operations"}
                isInteractionDisabled={isViewOnlyUtilization}
                isViewOnly={isViewOnlyUtilization}
              />
              {/* <UtilizationReport ongoingProjectsManager={ongoingProjectsManager} ongoingEntries={ongoingEntries} User={"Operations"} /> */}
            </div>
          )}
          </div>
        )}


        {/* OP */}
        {showprojectrequestPM && (
          <OPProjectRequestedPM EmpEmail={EmpEmail} filterRequestProjects={requestedprojectsDataPM} handlerefresh={handlerefresh} isViewOnly={isViewOnlyMyRequests} />
        )}
        {showaprovedPM && (
          <OPProjectapprovedPM EmpEmail={EmpEmail} approvedOpProjectsState={approvedProjectsManagerDataPM} handlerefresh={handlerefresh} isViewOnly={isViewOnlyMyRequests} />
        )}
        {showassignPM && (
          <OPProjectassignPM EmpEmail={EmpEmail} assignedOpProjects={assignedProjectsManagerDataPM} handlerefresh={handlerefresh} isViewOnly={isViewOnlyMyRequests} />
        )}

        {showongoingPM && (
          <OPProjectOngoingOPDashPM EmpEmail={EmpEmail} ongoingOpProjects={ongoingProjectsManagerDataPM} handlerefresh={handlerefresh} isViewOnly={isViewOnlyMyRequests} />
        )}
        {showcompletePM && (
          <OPProjectCompletedDashPM EmpEmail={EmpEmail} completeOpProjects={completeProjectsManagerDataPM} handlerefresh={handlerefresh} isViewOnly={isViewOnlyMyRequests} />
        )}
        {/* OP */}

        {/* OM */}
        {showprojectrequest && (
          <div className="pt-2">
            {/* Project Requested */}
            <div className=" bg-white" ref={ProjectRequestsRef}>
              <div className="rounded-lg  h-full justify-center ">
                <div className="flex flex-col">
                  <>
                    <div className="flex justify-between items-center bg-white rounded-t py-2 pr-2 z-[1400]">
                      <div className=" font-semibold text-md px-2">
                        Project Requests
                      </div>

                      <div className="flex gap-2 p-1 align-middle items-center bg-[#e0e7ff] rounded-full">
                        <MdSearch className=" w-5 h-5 text-gray-500" />
                        <input
                          type="text"
                          value={searchQuery}
                          onChange={handleSearchInputChange}
                          placeholder="Search"
                          className="bg-[#e0e7ff] outline-none w-[80%]"
                        />
                      </div>
                    </div>

                    <div
                      ref={ProjectRequestRef}
                      className="max-h-[80vh] w-full overflow-auto flex flex-col bg-white pb-20"
                    >
                      <div className="head sticky top-0 z-[1400] text-center text-sm flex font-semibold">
                        <div className="w-16 border text-xs flex-shrink-0 p-2 flex justify-center h-14 items-center align-middle bg-[#E8E8E8] text-black">
                          Sr. No
                        </div>
                        <div className="w-[16.6%] border flex-shrink-0 h-14 p-2 truncate flex justify-around items-center align-middle text-xs line-clamp-2 bg-[#E8E8E8] text-black">
                          <p className="w-[75%] break-words whitespace-normal text-start pl-2">
                            Group
                          </p>
                          <div className="w-[25%] flex flex-col">
                            <div
                              className="cursor-pointer "
                              onClick={() =>
                                sortAlphabetically("AssignedGroup", "az")
                              }
                            >
                              <ArrowDropUp
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>

                            <div
                              className="cursor-pointer -mt-2"
                              onClick={() =>
                                sortAlphabetically("AssignedGroup", "za")
                              }
                            >
                              <ArrowDropDown
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="w-[16.6%] h-14 border flex-shrink-0 p-2 truncate flex justify-around items-center align-middle text-xs line-clamp-2 bg-[#E8E8E8] text-black">
                          <p className="w-[75%] break-words whitespace-normal text-start pl-2">
                            Project Name
                          </p>
                          <div className="w-[25%] flex flex-col">
                            <div
                              className="cursor-pointer "
                              onClick={() =>
                                sortAlphabetically("ProjectName", "az")
                              }
                            >
                              <ArrowDropUp
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>

                            <div
                              className="cursor-pointer -mt-2"
                              onClick={() =>
                                sortAlphabetically("ProjectName", "za")
                              }
                            >
                              <ArrowDropDown
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="w-[16.6%] relative h-14 border flex-shrink-0 p-2 truncate flex justify-center items-center align-middle text-xs line-clamp-2 bg-[#E8E8E8] text-black">
                          <p className=" break-words whitespace-normal text-center pl-2">
                            Date Requested
                          </p>
                          <div className="absolute right-1 flex flex-col">
                            <div
                              className="cursor-pointer "
                              onClick={() =>
                                sortAlphabetically("DateRequested", "az")
                              }
                            >
                              <ArrowDropUp
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>

                            <div
                              className="cursor-pointer -mt-2"
                              onClick={() =>
                                sortAlphabetically("DateRequested", "za")
                              }
                            >
                              <ArrowDropDown
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="w-[16.6%] relative h-14 border flex-shrink-0 p-2 truncate flex justify-center items-center align-middle text-xs line-clamp-2 bg-[#E8E8E8] text-black">
                          <p className=" break-words whitespace-normal text-center pl-2">
                            Due Date
                          </p>
                          <div className=" absolute right-1 flex flex-col">
                            <div
                              className="cursor-pointer "
                              onClick={() =>
                                sortAlphabetically("ProjectDueDate", "az")
                              }
                            >
                              <ArrowDropUp
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>

                            <div
                              className="cursor-pointer -mt-2"
                              onClick={() =>
                                sortAlphabetically("ProjectDueDate", "za")
                              }
                            >
                              <ArrowDropDown
                                color="white"
                                sx={{ fontSize: "22px" }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="w-[11%] h-14 border flex-shrink-0 p-2 truncate flex justify-around items-center align-middle text-xs line-clamp-2 bg-[#E8E8E8] text-black">
                          Attachment
                        </div>
                        <div className="w-[16.6%] h-14 border flex-shrink-0 p-2 truncate flex justify-around items-center align-middle text-xs line-clamp-2 bg-[#E8E8E8] text-black">
                          Action
                        </div>

                        {expandedRowId && (
                          <div
                            className={`h-14 ${expandedRowId
                              ? "w-60  flex-shrink-0 bg-[#E8E8E8] text-black border "
                              : "w-[0%] hidden"
                              }`}
                          >
                            <div className="h-[50%] pt-1 w-full text-xs ">
                              Assign Task To Employees
                            </div>
                            <div className="h-[50%] flex w-full ">
                              <div className="w-[60%]  text-xs flex justify-center align-middle items-center">
                                Employee
                              </div>
                              <div className="w-[40%]  text-xs flex justify-center align-middle items-center">
                                Action
                              </div>
                            </div>
                          </div>
                        )}
                        {requestedprojects.some(
                          (row) => taskTableRowId === row?._id
                        ) ? (
                          <div
                            className=" 
                                 w-[30rem] bg-[#E8E8E8] text-black text-xs flex-shrink-0 h-14 "
                          >
                            <div className="h-[50%] p-1"> Tasklist </div>
                            <div className="h-[50%] flex w-full justify-center align-middle items-center">
                              {(Array.isArray(serviceofuser)
                                ? serviceofuser.some((service) =>
                                  ["Installation", "Software", "Cloud"].some(
                                    (keyword) => service.includes(keyword)
                                  )
                                )
                                : ["Installation", "Software", "Cloud"].some(
                                  (keyword) =>
                                    serviceofuser?.includes(keyword)
                                )) && (
                                  <div className="flex w-full">
                                    <div
                                      onClick={() => {
                                        syncToolGuideStep("fill-details");
                                        setAction("task");
                                      }}
                                      className={`cursor-pointer border  flex justify-center align-middle items-center w-[50%] py-1 px-2 text-start ${Action === "task"
                                        ? "bg-blue-500 text-white"
                                        : "bg-[#E8E8E8] text-black"
                                        }`}
                                    >
                                      Effort Expenses
                                    </div>
                                    <div
                                      onClick={() => {
                                        syncToolGuideStep("fill-details");
                                        setAction("otherExpenses");
                                      }}
                                      className={`cursor-pointer border  flex justify-center align-middle items-center w-[50%] py-1 px-2 text-start ${Action === "otherExpenses"
                                        ? "bg-blue-500 text-white"
                                        : "bg-[#E8E8E8] text-black"
                                        }`}
                                    >
                                      Other Expenses
                                    </div>
                                  </div>
                                )}

                              {(Array.isArray(serviceofuser)
                                ? serviceofuser.some((service) =>
                                  ["Hardware"].some((keyword) =>
                                    service.includes(keyword)
                                  )
                                )
                                : ["Hardware"].some((keyword) =>
                                  serviceofuser?.includes(keyword)
                                )) && (
                                  <div className="flex w-full bg-orange-300">
                                    <div
                                      onClick={() =>
                                        setHardwareAction("hardwarecost")
                                      }
                                      className={`cursor-pointer w-[50%] flex justify-center align-middle items-center py-1 px-2 text-start ${hardwareAction === "hardwarecost"
                                        ? "bg-blue-500 text-white"
                                        : "bg-[#E8E8E8] text-black"
                                        }`}
                                    >
                                      Hardware Costs
                                    </div>
                                    <div
                                      onClick={() =>
                                        setHardwareAction("otherexpenses")
                                      }
                                      className={`cursor-pointer w-[50%] flex justify-center align-middle items-center py-1 px-2 text-start ${hardwareAction === "otherexpenses"
                                        ? "bg-blue-500 text-white"
                                        : "bg-[#E8E8E8] text-black"
                                        }`}
                                    >
                                      Other Expenses
                                    </div>
                                  </div>
                                )}
                            </div>
                          </div>
                        ) : null}
                      </div>

                      <div className="max-h-[18rem] text-center bg-white text-sm flex flex-col">
                        {currentData.map((row, index) => {
                          console.log("currentData hardware1", currentData)
                          return (
                            <div
                              key={index}
                              className={`flex text-sm text-center ${row.isRead === false ? "font-bold" : " "
                                } `}
                            >
                              <div className="w-16 border-b flex-shrink-0 py-2 flex justify-center align-middle items-center">
                                {startIdx + index + 1}
                              </div>
                              <div
                                className={`w-[16.6%] border-b flex-shrink-0 p-2 truncate flex justify-start align-middle items-center text-xs line-clamp-2 
                                 ${row?.Assignedperson?.length > 0 &&
                                    row.Assignedperson.every(
                                      (person) => person?.taskStatus === "submit"
                                    )
                                    ? "font-bold text-green-500"
                                    : ""
                                  }`}
                              >
                                <span className="pl-2">{getDisplayGroupName(row)}</span>
                              </div>
                              <div className="w-[16.6%] border-b flex-shrink-0 p-2 truncate flex justify-start align-middle items-center text-xs line-clamp-2">
                                <span className={`${row?.Assignedperson?.length > 0 &&
                                  row.Assignedperson.every(
                                    (person) => person?.taskStatus === "submit"
                                  )
                                  ? "font-bold text-green-500"
                                  : ""
                                  } pl-2`}> {row.ProjectName}</span>
                              </div>
                              <div className="w-[16.6%] border-b flex-shrink-0 p-2 truncate flex justify-center align-middle items-center text-xs line-clamp-2">
                                <span className="">
                                  {" "}
                                  {row.DateRequested &&
                                    !isNaN(new Date(row.DateRequested))
                                    ? formatDateByCountry(row.DateRequested)
                                    : " "}
                                </span>
                              </div>
                              <div className="w-[16.6%] border-b flex-shrink-0 p-2 truncate flex justify-center align-middle items-center text-xs line-clamp-2">
                                <DatePicker
                                  selected={
                                    row.ProjectDueDate
                                      ? new Date(row.ProjectDueDate)
                                      : null
                                  }
                                  minDate={new Date()}
                                  onChange={(date) => {
                                    if (isViewOnlyMyRequests) return;
                                    handleDateDueChange(date, index);
                                  }}
                                  dateFormat={getDateFormat()}
                                  className={`w-full h-full text-center outline-none border border-gray-300 p-2 rounded-md bg-white ${isViewOnlyMyRequests ? "opacity-50 cursor-not-allowed" : ""}`}
                                  placeholderText={getDatePlaceholder()}
                                  disabled={
                                    row.ProjectManagerAction === "rejected" || isViewOnlyMyRequests
                                  }
                                  popperClassName="z-[1500]"
                                />
                              </div>

                              <div className="w-[11%] border-b flex-shrink-0 p-2 truncate flex justify-center align-middle items-center text-xs line-clamp-2">
                                <FileAttachmentPopup
                                  leads={leads}
                                  row={row}
                                  selectedAction={selectedAction}
                                  popupProject={popupProject}
                                  setPopupProject={setPopupProject}
                                  handleFileChange={handleFileChange}
                                  handleFileDelete={handleFileDelete}
                                  fileNames={fileNames}
                                  bufferToUint8Array={bufferToUint8Array}
                                  enqueueSnackbar={enqueueSnackbar}
                                  employees={employees}
                                  isViewOnly={isViewOnlyMyRequests}
                                />
                              </div>

                              <div className="w-[16.6%] border-b flex-shrink-0 flex justify-center align-middle items-center  pt-1">
                                <ActionDropdown
                                  handlerefresh={handlerefresh}
                                  handleleadread={handleleadread}
                                  projects={projects}
                                  index={index}
                                  row={row}
                                  dropdownRefs={dropdownRefsProbability}
                                  openIndex={openProbabilityIndex}
                                  setOpenIndex={setOpenProbabilityIndex}
                                  setProject={setProject}
                                  handleReject={handleReject}
                                  probabilityList={probabilityList}
                                  setExpandedRowId={setExpandedRowId}
                                  setSelected={setSelected}
                                  selected={selected}
                                  setTaskTableRowId={setTaskTableRowId}
                                  SetShowprojectDetails={SetShowprojectDetails}
                                  setServiceofuser={setServiceofuser}
                                  isViewOnly={isViewOnlyMyRequests}
                                />
                              </div>

                              {/* Assign Task To Employee Column */}
                              <div
                                className={`${expandedRowId ? "w-60" : "w-0 hidden "
                                  } flex-shrink-0 flex border-b flex-col justify-start align-top items-start p-0`}
                              >
                                <>
                                  {/* {row.Assignedperson.length > 0 && ( */}
                                  {expandedRowId === row?._id ? (
                                    <>
                                      {/* Close row - above Self; closes Assign Task block and Tasklist/Effort/Other Expenses */}
                                      <div
                                        className="w-full flex justify-end items-center border-b py-1 px-2 cursor-pointer hover:bg-gray-200 text-xs text-blue-600"
                                        onClick={() => {
                                          setExpandedRowId(null);
                                          setTaskTableRowId(null);
                                        }}
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(e) => {
                                          if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            setExpandedRowId(null);
                                            setTaskTableRowId(null);
                                          }
                                        }}
                                      >
                                        Close
                                      </div>
                                    <AssignedPersonList
                                      selectedActions={selectedActions}
                                      setSelectedActions={setSelectedActions}
                                      employees={employees}
                                      entries={entries}
                                      tasks={descriptionTasksMergedForAssignmentRow(row)}
                                      items={items}
                                      handleforwardself={handleforwardself}
                                      SetisLoading={SetisLoading}
                                      setRowsManager={setRowsManager}
                                      isSelfChecked={
                                        checkedRows[row?._id] || false
                                      }
                                      setIsSelfChecked={(checked) => {
                                        setCheckedRows((prev) => ({
                                          ...prev,
                                          [row?._id]: checked,
                                        }));
                                      }}
                                      setselectedselfemail={setselectedselfemail}
                                      setManagerSelectedEmpOnChange={
                                        setManagerSelectedEmpOnChange
                                      }
                                      setRows={setRows}
                                      setTaskTableRowId={setTaskTableRowId}
                                      row={row}
                                      index={index}
                                      activeDropdownId={activeDropdownId}
                                      dropdownRef={dropdownRef}
                                      handleTaskTableClick={handleTaskTableClick}
                                      SetShowprojectDetails={
                                        SetShowprojectDetails
                                      }
                                      setManagerViewEmpTask={
                                        setManagerViewEmpTask
                                      }
                                      setManagerSelectedEmp={
                                        setManagerSelectedEmp
                                      }
                                      setSourceName={setSourceName}
                                      handleMenuToggle={handleMenuToggle}
                                      handleManagerAction={handleManagerAction}
                                      Project={Project}
                                      setSelectedEmail={setSelectedEmail}
                                      setSelectedProject={setSelectedProject}
                                      setSelectedServiceType={
                                        setSelectedServiceType
                                      }
                                      setManagerOPID={setManagerOPID}
                                      setManagerOPProject={setManagerOPProject}
                                      handleComplete={handleComplete}
                                      setopemail={setopemail}
                                      dropdownRefs={dropdownRefs}
                                      handleDropdownChange={handleDropdownChange}
                                      openDropdownIndex={openDropdownIndex}
                                      setOpenDropdownIndex={setOpenDropdownIndex}
                                      assignedPeopleList={assignedPeopleList}
                                      employeesfinalList={employeesfinalList}
                                      setAssignedPeopleList={
                                        setAssignedPeopleList
                                      }
                                      setServiceofuser={setServiceofuser}
                                      handleCompleteself={handleCompleteself}
                                      handleselfcancel={handleselfcancel}
                                      setIsOpen={setIsOpen}
                                      isOpen={isOpen}
                                      selectedActionComplete={
                                        selectedActionComplete
                                      }
                                      setSelectedSelfAction={
                                        setSelectedSelfAction
                                      }
                                      selectedSelfAction={selectedSelfAction}
                                      setSelectedActionComplete={
                                        setSelectedActionComplete
                                      }
                                      handleselfreview={handleselfreview}
                                      setIsSelfChecke={setIsSelfChecke}
                                      isSelf={isSelf}
                                      isViewOnly={isViewOnlyMyRequests}
                                      showprojectDetails={showprojectDetails}
                                    />
                                    </>
                                  ) : (
                                    <div className=" w-60 h-full"></div>
                                  )}
                                  {/* )} */}
                                </>
                              </div>

                              {/* Task Table Column */}
                              {taskTableRowId && (
                                <div className="w-[30rem] max-h-[50rem] flex-shrink-0 border-b">
                                  {row.TypeService === "Hardware" ? (
                                    <>
                                      <HardwareParent
                                        handlerehardfresh={handlerehardfresh}
                                        handlerefreshagain={handlerefreshagain}
                                        handlerefresh={handlerefresh}
                                        autosaveentries={autosaveentries}
                                        // hardwareData={hardwareData}
                                        employees={employees}
                                        entries={entries}
                                        tasks={descriptionTasksMergedForAssignmentRow(row)}
                                        items={items}
                                        sourceName={sourceName}
                                        totalHours={totalHours}
                                        handleAddRow={handleAddRow}
                                        handleRemoveRow={handleRemoveRow}
                                        row={row}
                                        Action={Action}
                                        setAction={setAction}
                                        hardwareAction={hardwareAction}
                                        setHardwareAction={setHardwareAction}
                                        taskTableRowId={taskTableRowId}
                                        setSelectedActions={setSelectedActions}
                                        hardwareData={inventory}
                                        opemail={opemail}
                                        handleAddRowManagerEdit={
                                          handleAddRowManagerEdit
                                        }
                                        selectedemail={selectedemail}
                                        selectedProject={selectedProject}
                                        selectedServiceType={selectedServiceType}
                                        isLoadingtask={isLoadingtask}
                                        SetisLoadingtask={SetisLoadingtask}
                                        managerOPID={managerOPID}
                                        managerOPProject={managerOPProject}
                                        SetisLoading={SetisLoading}
                                        showprojectDetails={showprojectDetails}
                                        managerViewEmpTask={managerViewEmpTask}
                                      />
                                    </>
                                  ) : (
                                    <>
                                      {taskTableRowId === row?._id ? (
                                        showprojectDetails && (
                                          <TaskInputTable
                                            handlerehardfresh={handlerehardfresh}
                                            handlerefreshagain={handlerefreshagain}
                                            handlerefresh={handlerefresh}
                                            autosaveentries={autosaveentries}
                                            hardwareData={hardwareData}
                                            employees={employees}
                                            entries={entries}
                                            tasks={descriptionTasksMergedForAssignmentRow(row)}
                                            items={items}
                                            sourceName={sourceName}
                                            rows={rows}
                                            setRows={setRows}
                                            totalHours={totalHours}
                                            handleAddRow={handleAddRow}
                                            handleRemoveRow={handleRemoveRow}
                                            // handleCreateTask={handleCreateTask}

                                            isLoadingtask={isLoadingtask}
                                            row={row}
                                            Action={Action}
                                            setAction={setAction}
                                            hardwareAction={hardwareAction}
                                            setHardwareAction={setHardwareAction}
                                            taskTableRowId={taskTableRowId}
                                          />
                                        )
                                      ) : (
                                        <div className=" w-60 h-full"></div>
                                      )}

                                      {taskTableRowId === row?._id ? (
                                        managerViewEmpTask && (
                                          <ManagerTaskInputTable
                                            setSelectedActions={setSelectedActions}
                                            hardwareData={inventory}
                                            employees={employees}
                                            entries={entries}
                                            tasks={descriptionTasksMergedForAssignmentRow(row)}
                                            items={items}
                                            opemail={opemail}
                                            sourceName={sourceName}
                                            handleAddRowManagerEdit={
                                              handleAddRowManagerEdit
                                            }
                                            selectedemail={selectedemail}
                                            selectedProject={selectedProject}
                                            selectedServiceType={selectedServiceType}
                                            isLoadingtask={isLoadingtask}
                                            SetisLoadingtask={SetisLoadingtask}
                                            managerOPID={managerOPID}
                                            managerOPProject={managerOPProject}
                                            setRowsManager={setRowsManager}
                                            rowsManager={rowsManager}
                                            SetisLoading={SetisLoading}
                                            row={row}
                                            Action={Action}
                                            setAction={setAction}
                                            hardwareAction={hardwareAction}
                                            setHardwareAction={setHardwareAction}
                                            handlerefreshagain={handlerefreshagain}
                                            handlerefresh={handlerefresh}
                                            taskTableRowId={taskTableRowId}
                                            isProjectRequestedBucket={true}
                                          />
                                        )
                                      ) : (
                                        <div className=" w-60 h-full"></div>
                                      )}
                                    </>
                                  )}
                                </div>
                              )}
                            </div>
                          )
                        })}
                        {currentData.length === 0 && (
                          <div className="noDataAvailable p-2 text-start">
                            No Result Found
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="mt-3">
                      {currentData.length > 0 && (
                        <div className="pagination p-3 flex justify-between items-center bg-white rounded-md pb-2">
                          <div>
                            {totalItems > 0 ? (
                              <>
                                Showing {startIdx + 1} to{" "}
                                {Math.min(endIdx, totalItems)} of {totalItems}{" "}
                                Entries
                              </>
                            ) : (
                              <>Showing 0 Entries</>
                            )}
                          </div>
                          {totalPages > 1 && (
                            <div>
                              <button
                                onClick={() => setCurrentPage(1)}
                                className="px-2 py-2 mx-1 border rounded"
                                disabled={currentPage === 1}
                                title="First Page"
                              >
                                <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
                              </button>
                              <button
                                onClick={() =>
                                  setCurrentPage((prev) =>
                                    Math.max(prev - 1, 1)
                                  )
                                }
                                className="px-2 py-2 mx-2 border rounded"
                                disabled={currentPage === 1}
                              >
                                <ChevronRightIcon className="w-5 h-5 rotate-180" />

                                {/* Previous */}
                              </button>

                              {Array.from({ length: 3 }, (_, index) => {
                                // Calculate the page number for the current range
                                const pageNumber = currentPage - 1 + index;

                                // Ensure the pageNumber stays within bounds
                                if (
                                  pageNumber >= 1 &&
                                  pageNumber <= totalPages
                                ) {
                                  return (
                                    <button
                                      key={pageNumber}
                                      onClick={() => setCurrentPage(pageNumber)}
                                      className={`px-2 py-2 mx-2 border rounded ${currentPage === pageNumber
                                        ? "bg-gray-300"
                                        : ""
                                        }`}
                                    >
                                      {pageNumber}
                                    </button>
                                  );
                                }

                                // Return null for out-of-bounds values
                                return null;
                              })}

                              <button
                                onClick={() =>
                                  setCurrentPage((prev) =>
                                    Math.min(prev + 1, totalPages)
                                  )
                                }
                                className="px-4 py-2 mx-2 border rounded"
                                disabled={currentPage === totalPages}
                              >
                                <ChevronRightIcon className="w-5 h-5" />
                                {/* Next */}
                              </button>
                              <button
                                onClick={() => setCurrentPage(totalPages)}
                                className="px-2 py-2 mx-1 border rounded"
                                disabled={currentPage === totalPages}
                                title="Last Page"
                              >
                                <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </>
                </div>
              </div>
            </div>

            {/* )} */}
          </div>
        )}

        {showaproved && (
          <div className="pt-2" ref={ProjectApprovedRef}>
            <OmProjectApprovedDash
              approvedProjectsManager={approvedProjectsManager}
              handlerefresh={handlerefresh}
              isViewOnly={isViewOnlyMyRequests}
            />
          </div>
        )}

        {showassign && (
          <div className="pt-2" ref={ProjectAssignedRef}>
            <ProjectAssignManager isViewOnly={isViewOnlyMyRequests} />
          </div>
        )}

        {showongoing && (
          <div className="pt-2" ref={ProjectOngoingRef}>
            <ProjectOngoingManager
              ongoingProjectsManager={ongoingProjectsManager}
              handlerefresh={handlerefresh}
              isViewOnly={isViewOnlyMyRequests}
            />
          </div>
        )}
        {showcomplete && (
          <div className="pt-2" ref={ProjectCompletedRef}>
            <ProjectCompletedManager
              completeProjectsManager={completeProjectsManager}
              handlerefresh={handlerefresh}
              isViewOnly={isViewOnlyMyRequests}
            />
          </div>
        )}
        {/* OM */}

        {canShowCard("MY TRAININGS") && (
          <div className="w-full pt-2">
            {["L3", "L4"].includes(loggedEmp?.EmpAuthLevel) && <MyTraining />}
          </div>
        )}

        {(hasNoFeatureConfig || hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS")) && (
          <div className="w-full pt-2" id="manager-p-and-l">
            {["L4"].includes(loggedEmp?.EmpAuthLevel) && <ManagerFinance isViewOnly={isViewOnlyPL} />}
          </div>
        )}


        {showcompletepopup && (
          <div className="fixed inset-0 z-[1400] flex items-center justify-center bg-[rgba(0,0,0,0.4)] bg-opacity-50">
            <div className="bg-white rounded-lg p-4 max-w-2xl w-[80%] max-h-[90vh] overflow-auto relative">
              <button
                onClick={() => {
                  Setshowcompletepopup(false);
                  setSelectedActionComplete("");
                  setSelectedSelfAction("");
                  setSelectedActions({});
                }}
                className="absolute top-2 right-2 text-red-500 text-xl font-bold mr-6"
              >
                Close
              </button>

              <h2 className="">
                Project Name :{" "}
                <span className="font-semibold">
                  {showcompleteproject?.ProjectName}
                </span>
              </h2>

              <p className="mt-3  leading-6">
                Are you sure you want to complete all response of
                <span className="text-blue-800 font-semibold">
                  {" "}
                  {showcompleteperson.name}{" "}
                </span>{" "}
                <br /> including effort expenses and other expenses ?
              </p>

              <div className="flex justify-start gap-4 mt-4">
                <button
                  onClick={() => {
                    handleCompletesubmit();
                  }}
                  className="py-2 px-7 bg-[#e32278] text-white rounded-lg"
                >
                  Yes
                </button>
                <button
                  onClick={() => {
                    Setshowcompletepopup(false);
                    setSelectedActionComplete("");
                    setSelectedSelfAction("");
                    setSelectedActions({});
                  }}
                  className="py-2 px-7 bg-black hover:bg-white hover:text-black border border-black text-white rounded-lg"
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )}

        {showselfcompletepopup && (
          <div className="fixed inset-0 z-[1400] flex items-center justify-center bg-[rgba(0,0,0,0.4)] bg-opacity-50">
            <div className="bg-white rounded-lg p-4 max-w-2xl w-[80%] max-h-[90vh] overflow-auto relative">
              <button
                onClick={() => {
                  Setshowselfcompletepopup(false);
                  setSelectedActionComplete("");
                  setSelectedSelfAction();
                }}
                className="absolute top-2 right-2 text-red-500 text-xl font-bold mr-6"
              >
                Close
              </button>

              <h2 className="">
                Project Name :{" "}
                <span className="font-semibold">
                  {selfcompleterow?.ProjectName}
                </span>
              </h2>

              <p className="mt-3  leading-6">
                Are you sure you want to complete all response of
                <span className="text-blue-800 font-semibold">
                  {" "}
                  Yourself{" "}
                </span>{" "}
                <br /> including effort expenses and other expenses ?
              </p>

              <div className="flex justify-start gap-4 mt-4">
                <button
                  onClick={() => {
                    handleComplete(selfcompleterow);
                  }}
                  className="py-2 px-7 bg-[#e32278] text-white rounded-lg"
                >
                  Yes
                </button>
                <button
                  onClick={() => {
                    Setshowselfcompletepopup(false);
                    handlerefresh();
                    setSelectedActionComplete("");
                    setSelectedSelfAction("");
                  }}
                  className="py-2 px-7 bg-black hover:bg-white hover:text-black border border-black text-white rounded-lg"
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )}
        <div>{/* <EmployeeReview/> */}</div>
      </div>
    </>
  );
};
export default ManagerAssignment;
